import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { convertToGrayScale, loadImageDimensions, parseAmount } from "../modules/invoiceUtils";

export const Browser4InchBillReceiptM2 = async (
   data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings
) => {
  const {
    documentConfig,hasPayment       
  } = invoiceConfig;
  const doc = new jsPDF({
    unit: "pt",
    format: [288, 1000],
  });

  const pageWidth = doc.internal.pageSize.getWidth();

  let y = 10;

  const isIGST =
    documentConfig?.fromData?.statecode &&
    documentConfig?.toData?.statecode &&
    documentConfig?.fromData.statecode !== documentConfig?.toData.statecode;

  const taxRows = documentConfig?.items?.reduce((acc, product) => {
    const taxPercentage = product.taxpercentage || 0;
    const taxAmount = product.lineTotalTaxAmount || 0;
    const basePrice = product.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});
  const checkPageBreak = (doc, y, buffer = 20) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    if (y + buffer >= pageHeight) {
      doc.addPage();
      return 14;
    }
    return y;
  };
  // const storeBoxStartY = y;

 const imagePath =  documentConfig?.image;

  // const imagePath = settings?.saleProfileData?.image
  //   ?  settings?.saleProfileData?.image
  //   : "/assets/images/logo-light.png";

  if (documentConfig?.image) {
    try {
      // Step 1: Convert image URL to base64
      const response = await fetch(imagePath, { mode: "cors" });
      const blob = await response.blob();
      let base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      // Step 2: Convert to grayscale
      base64 = await convertToGrayScale(base64);

      // Step 3: Get natural dimensions
      const { width: naturalWidth, height: naturalHeight } =
        await loadImageDimensions(base64);

      // Step 4: Resize to fit dynamically within maxWidth and maxHeight
      const maxWidth = 80; // maximum width in pt for 3-inch receipt
      const maxHeight = 40; // maximum height in pt
      const widthRatio = maxWidth / naturalWidth;
      const heightRatio = maxHeight / naturalHeight;
      const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

      const imgWidth = naturalWidth * ratio;
      const imgHeight = naturalHeight * ratio;

      // Step 5: Center the logo
      const logoX = (pageWidth - imgWidth) / 2;

      doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

      y += imgHeight + 20; // spacing after logo
    } catch (err) {
      console.warn("Logo failed to load:", err);
    }
  }

  let margin = 15;
  const drawDashedLine = (yPos) => {
    doc.setLineDash([3, 3], 0);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    doc.setLineDash([]); // Reset to solid
  };
  // Header

  doc.setFont("NotoSansMono-Bold", "bold");

  doc.setFontSize(13);
  const storeTitle = documentConfig?.fromData?.title || "Store";
  doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
    doc.text(line, pageWidth / 2, y, { align: "center" });
    y += 13;
  });
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(12);
  const seller = documentConfig?.fromData;
  const sellerAddressParts = [
    seller?.addressline1,
    [seller?.state].filter(Boolean).join(", "),
  ].filter(Boolean);
  doc
    .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 50)
    .forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 10;
    });

  // if (seller?.email) {
  //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
  //   y += 16;
  // }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9); // Slightly smaller to match UI

  const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
  doc.text(addressText, pageWidth / 2, y, { align: "center" });
  y += 10;
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  // const gstText = `GST: ${seller?.gstnumber || ""}`;
  const phoneText = `Ph: ${documentConfig?.fromData?.phone
            ? `${documentConfig.fromData.phone}`
            : ""
        }${
          documentConfig?.fromData?.additionalPhone
            ? `, ${documentConfig.fromData.additionalPhone}`
            : ""
        }`;
  const cinTest = `CIN: ${seller?.cinnumber || ""}`;
  const panTex = `PAN: ${seller?.pannumber || ""}`;

  const horizontalPadding = 12;
  const leftStart = horizontalPadding;
  const rightEnd = pageWidth - horizontalPadding;
  doc.text(panTex, leftStart, y, { align: "left" });
  doc.text(phoneText, rightEnd, y, { align: "right" });
  y += 10;

  const fassiTest = `FASSI: ${seller?.fssai || ""}`;

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  {
    seller?.fssai && doc.text(fassiTest, leftStart, y, { align: "left" });
    y += 10;
  }
  {
    seller?.cinnumber && doc.text(cinTest, leftStart, y, { align: "left" });
  }
  y += 10;

  const storeBoxPadding = 4;

  doc.setLineWidth(1);
  doc.setLineDash([1, 1]); // solid border

  y += 8;
   const invoiceTitle =
    data?.status === "CANCELLED"
      ? "CANCELLED TAX INVOICE"
      :documentConfig?.title;

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(11);
  const textWidth = doc.getTextWidth(invoiceTitle);
  const gap = 8; // Space between the line and the text
  margin = 10;
  // 5. Draw the Lines
  let centerX = pageWidth / 2;
  doc.text(invoiceTitle, centerX, y, { align: "center" });
  doc.setLineWidth(1);
  doc.setLineDash([3, 3]); // Use [0] for a solid line, [2, 2] for dashed like your image

  // Left Line: starts at margin, ends just before the text
  doc.line(margin, y - 4, centerX - textWidth / 2 - gap, y - 4);

  // Right Line: starts just after the text, ends at margin
  doc.line(centerX + textWidth / 2 + gap, y - 4, pageWidth - margin, y - 4);

  // 6. Reset Dash and move Y
  doc.setLineDash([]);
  y += 15;

  const { date, time } = documentConfig?.Date
  const lineHeight = 13; // Adjusted for tighter spacing seen in UI
  const leftColX = 8; // Left margin
  const rightColX = pageWidth / 2 + 10; // Start of the second column
  const drawField = (label, value, xPos, yPos) => {
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    const fieldText = `${label} : ${value}`;
    doc.text(fieldText, xPos, yPos);
  };
  drawField(documentConfig?.numberLabel, `${documentConfig?.number}`, leftColX, y);
  // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
  y += lineHeight;

  // Row 2: Date
  drawField("Date", `${date}, ${time}`, leftColX, y);
  y += lineHeight;

  // Row 3: Cashier
  // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

  const labelX = 8; // Left-aligned label start
  const colonX = 110; // Colon aligned at this point
  const valueX = 120; // Value starts after colon

  // y += 12;
  const buyer = documentConfig?.toData;
  const hasBuyerInfo =
    buyer &&
    (buyer?.name ||
      buyer?.phone ||
      buyer?.addressline1 ||
      buyer?.email ||
      buyer?.gstnumber ||
      buyer?.pannumber ||
      buyer?.cinnumber);

  if (hasBuyerInfo) {
    // 1. Section Header: Clean and Centered
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
    y += 13;

    const leftMargin = 10;
    const lineHeight = 16;

    // 2. Buyer Name: Bold and Uppercase for Impact
    if (buyer.name) {
      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(9);
      doc.text(buyer.name.toUpperCase(), leftMargin, y);
      y += lineHeight;
    }

    // 3. Buyer Details: Smaller and Regular font
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);

    // Contact Row (Phone & Email)
    if (buyer.phone || buyer.email) {
      const contactLine = [
        buyer.phone ? `Ph: ${buyer.phone}` : null,
        buyer.email ? `Email: ${buyer.email}` : null,
      ]
        .filter(Boolean)
        .join(" | ");

      doc.text(contactLine, leftMargin, y);
      y += lineHeight;
    }

    // Address: Handling long text with splitTextToSize
    const addressParts = [
      buyer.addressline1,
      [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
      buyer.pincode ? `- ${buyer.pincode}` : null,
    ]
      .filter(Boolean)
      .join(", ");

    if (addressParts) {
      const splitAddress = doc.splitTextToSize(addressParts, pageWidth - 20);
      splitAddress.forEach((line) => {
        doc.text(line, leftMargin, y);
        y += lineHeight;
      });
    }

    // 4. Statutory IDs (GST, PAN, CIN): Compact layout
    const idList = [
      { label: "GST: ", value: buyer.gstnumber, bold: true, },
      { label: "PAN: ", value: buyer.pannumber, bold: true, },
      { label: "CIN: ", value: buyer.cinnumber, bold: true, },
      { label: "FSSAI: ", value: buyer.fssai,bold: true, },
      { label: "Reference No: ", value: buyer.referenceid, bold: false, },
    ];
    idList.forEach((item) => {
      if (item.value) {
        const leftMargin = 10;

        // 1. Draw the Label in BOLD
         if (item.bold) {
          doc.setFont("NotoSansMono-Bold", "bold");
        } else {
          doc.setFont("NotoSansMono-Regular", "normal");
        }
        doc.setFontSize(9);
        doc.text(item.label, leftMargin, y);

        // 2. Calculate label width so the value starts exactly after it
        const labelWidth = doc.getTextWidth(item.label);

        // 3. Draw the Value in REGULAR
        doc.setFont("NotoSansMono-Regular", "normal");
        doc.text(`${item.value}`, leftMargin + labelWidth, y);

        // 4. Move to next line
        y += 14;
      }
    });

    y += 5; // Extra spacing before the items table starts
  }

  const tableMargin = 8;
  const tableWidth = pageWidth - tableMargin * 2;

  autoTable(doc, {
    startY: y,
    margin: { left: tableMargin, right: tableMargin },
    theme: "plain",
    // 1. Set global border styles
    styles: {
      fontSize: 10,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black", // Light gray border
      lineWidth: 1,
      font: "NotoSansMono-Regular",
    },
    head: [
      // Header Row 1: "Items" label span
      [
        {
          content: "Items",
          colSpan: 3,
          styles: {
            halign: "left",
            fontStyle: "bold",
            lineWidth: { left: 1, right: 1, top: 1, bottom: 0 },
          },
        },
      ],
      // Header Row 2: Rate, Qty, Total
      [
        {
          content: "Rate",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { left: 1, top: 0, bottom: 1 },
          },
        },
        {
          content: "Qty",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { top: 0, bottom: 1 },
          },
        },
        {
          content: "Total",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { right: 1, top: 0, bottom: 1 },
          },
        },
      ],
    ],
    body: documentConfig?.items.flatMap((item) => [
      // Line 1: Item Name (Full width)
      [
        {
          content: item.title + (item.note ? ` (${item.note})` : ""),
          colSpan: 3,
          styles: {
            halign: "left",
            lineWidth: { left: 1, right: 1, top: 0, bottom: 0 },
          },
        },
      ],
      // Line 2: Values (Rate, Qty, Total)
      [
        {
          content: `${item.soldprice}`,
          styles: {
            halign: "center",
            lineWidth: { left: 1, top: 0, bottom: 0 },
          },
        },
        {
          content: `${item?.quantity} ${(() => {
            const unitCode = item?.isSecondaryUnit
              ? item?.unitConfig?.secondaryUnitCode
              : item?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
        },
        {
          content: `${item.lineTotalSoldPrice}`,
          styles: {
            halign: "center",
            lineWidth: { right: 1, top: 0, bottom: 0 },
          },
        },
      ],
    ]),
    // 3. Close the bottom border on the last row
    didDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) {
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Set dimensions for the boxes
  const boxPadding = 8;
  let boxWidth = (pageWidth - 24) / 2; // Split page width minus margins
  const boxHeight = 45; // Height to accommodate two lines of text
  const startX = 8;
  const rightBoxX = startX + boxWidth + 8;

  // --- 1. Draw Left Box (Qty & Items) ---
  doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
  doc.setLineWidth(1); // Light gray border
  doc.roundedRect(startX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(12);
  // Qty Line
  // doc.text("Qty :", startX + 5, y + 18);
  // doc.text(`${data.totalqty || 0}`, startX + boxWidth - 5, y + 18, { align: "right" });
  // Items Line
  doc.text("Items :", startX + 5, y + 25);
  doc.text(`${data?.totalItems}`, startX + boxWidth - 5, y + 25, {
    align: "right",
  });

  // --- 2. Draw Right Box (Total Amount) ---
  doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(12);
  const totalLabel = "Grand Total";
  const totalValue = `${documentConfig?.grandTotal}`; // Assuming raw number as per UI
  const boxCenterX = rightBoxX + boxWidth / 2;

  // Draw Label: Centered horizontally
  doc.text(totalLabel, boxCenterX, y + 18, { align: "center" });

  doc.setFontSize(13);
  doc.text(totalValue, boxCenterX, y + 38, { align: "center" });

  // // Center the content within the right box
  // const combinedText = `${totalLabel} ${totalValue}`;
  // const textWidth1 = doc.getTextWidth(combinedText);
  // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

  // doc.text(totalLabel, textStartX, y + 26);
  // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

  y += boxHeight + 10; // Advance Y position for next section

  y = checkPageBreak(doc, y);
  const boxMargin = 8;
  // 1. Prepare payment list (Only show modes with value)
  const payments = [
    { label: "Cash", amount: documentConfig?.cashPaid },
    { label: "Card", amount: documentConfig?.cardPaid },
    { label: "Online Pay", amount: documentConfig?.onlinePaid },
    { label: "UPI", amount: documentConfig?.upiPaid },
    { label: "Balance Due", amount: documentConfig?.balanceDue },
  ].filter((p) => Math.abs(parseAmount(p.amount)) > 0);

  autoTable(doc, {
    startY: y,
    theme: "plain",
    margin: { left: boxMargin, right: boxMargin },
    styles: {
      font: "NotoSansMono-Regular",
      fontSize: 9,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black",
      lineWidth: 1,
    },
    head:hasPayment
    ?  [
      [
        {
          content: "PAYMENT MODE",
          colSpan: 3,
          styles: {
            font: "NotoSansMono-Bold",
            fontSize: 9,
            cellPadding: 1,
            fontStyle: "bold",
            lineWidth: { top: 1, left: 1, right: 1, bottom: 1 },
          },
        },
      ],
    ]: [],
    body: [ 
      ...(hasPayment
      ?payments.map((p) => [
        { content: p.label, styles: { fontSize: 9, lineWidth: { left: 1 } } },
        { content: ":", styles: { halign: "center", lineWidth: 0 } },
        {
          content: `${p.amount}`,
          styles: { halign: "right", lineWidth: { right: 1 }, fontSize: 9 },
        },
      ])  : []),
      // Bottom Right Footer for Tender and Balance
      [
        {
          // content: `Tender: ${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
          content: `Grand Total:   ${documentConfig?.grandTotal}`,
          colSpan: 5,
          styles: {
            halign: "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            fontSize: 12,
            cellPadding: 2,
            lineWidth: { left: 1, right: 1, bottom: 1, top: 1 },
          },
        },
      ],
    ],
    columnStyles: {
      0: { cellWidth: "auto" },
      1: { cellWidth: "20" },
      2: { cellWidth: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 15;

  y = checkPageBreak(doc, y);
  if (parseAmount(documentConfig?.totalDiscount) > 0) {
    const boxMargin = 8;
    const boxHeight = 20;
    const boxWidth = pageWidth - boxMargin * 2;
    // o 1
    // 1. Draw the Container Box
    doc.setDrawColor(0); // Light Gray border
    doc.setLineWidth(1);
    doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

    // 2. Set Font for the content
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);

    const savedAmount = `${documentConfig?.totalDiscount}`;
    doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + 4, y + 14);

    // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

    y += boxHeight + 10;
  }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);

  y += 5;
  doc.setFontSize(8);
  doc.text("Thank you for your purchase!", pageWidth / 2, y, {
    align: "center",
  });
  y += 10;
  doc.setFont("NotoSansMono-Bold", "bold");
  doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
  const thankBoxPadding = 10;
  y += 10;

  doc.setFont("NotoSansMono-Regular", "normal");
  doc.text("Powered By", pageWidth / 2, y, { align: "center" });
  y += 10;
  doc.setFontSize(8);
  const sitePrefix = "www.";
  const siteBold = "NegoBill";
  const siteSuffix = ".com";
  const prefixWidth = doc.getTextWidth(sitePrefix);
  const boldWidth = doc.getTextWidth(siteBold);
  const suffixWidth = doc.getTextWidth(siteSuffix);
  const totalWidth = prefixWidth + boldWidth + suffixWidth;
  const startX1 = (pageWidth - totalWidth) / 2;
  if (storeSettings?.negobillBranding) {
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(sitePrefix, startX1, y);
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text(siteBold, startX1 + prefixWidth, y);
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
  }
  y += 10;
  // setPrint(false);
  return doc;
};

export const Browser4InchInvoiceReceiptM2 = async (
  data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings
) => {
  const {
    documentConfig,hasPayment   
  } = invoiceConfig;
  const doc = new jsPDF({
    unit: "pt",
    format: [288, 1000],
  });
  const pageWidth = doc.internal.pageSize.getWidth();

  let y = 10;

  const isIGST =
    documentConfig?.fromData?.statecode &&
    documentConfig?.toData?.statecode &&
    documentConfig?.fromData.statecode !== documentConfig?.toData.statecode;

  const taxRows = documentConfig?.items?.reduce((acc, product) => {
    const taxPercentage = product.taxpercentage || 0;
    const taxAmount = product.lineTotalTaxAmount || 0;
    const basePrice = product.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});
  const checkPageBreak = (doc, y, buffer = 20) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    if (y + buffer >= pageHeight) {
      doc.addPage();
      return 14;
    }
    return y;
  };
  // const storeBoxStartY = y;

 const imagePath =  documentConfig?.image;

  // const imagePath = settings?.saleProfileData?.image
  //   ?  settings?.saleProfileData?.image
  //   : "/assets/images/logo-light.png";

  if (documentConfig?.image) {
    try {
      // Step 1: Convert image URL to base64
      const response = await fetch(imagePath, { mode: "cors" });
      const blob = await response.blob();
      let base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      // Step 2: Convert to grayscale
      base64 = await convertToGrayScale(base64);

      // Step 3: Get natural dimensions
      const { width: naturalWidth, height: naturalHeight } =
        await loadImageDimensions(base64);

      // Step 4: Resize to fit dynamically within maxWidth and maxHeight
      const maxWidth = 80; // maximum width in pt for 3-inch receipt
      const maxHeight = 40; // maximum height in pt
      const widthRatio = maxWidth / naturalWidth;
      const heightRatio = maxHeight / naturalHeight;
      const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

      const imgWidth = naturalWidth * ratio;
      const imgHeight = naturalHeight * ratio;

      // Step 5: Center the logo
      const logoX = (pageWidth - imgWidth) / 2;

      doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

      y += imgHeight + 20; // spacing after logo
    } catch (err) {
      console.warn("Logo failed to load:", err);
    }
  }

  let margin = 15;
  const drawDashedLine = (yPos) => {
    doc.setLineDash([3, 3], 0);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    doc.setLineDash([]); // Reset to solid
  };
  // Header

  doc.setFont("NotoSansMono-Bold", "bold");

  doc.setFontSize(13);
  const storeTitle = documentConfig?.fromData?.title || "Store";
  doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
    doc.text(line, pageWidth / 2, y, { align: "center" });
    y += 13;
  });
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  const seller = documentConfig?.fromData;
  const sellerAddressParts = [
    seller?.addressline1,
    [seller?.state].filter(Boolean).join(", "),
  ].filter(Boolean);
  doc
    .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 50)
    .forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 9;
    });

  // if (seller?.email) {
  //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
  //   y += 16;
  // }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9); // Slightly smaller to match UI

  const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
  doc.text(addressText, pageWidth / 2, y, { align: "center" });
  y += 10;
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  const gstText = `GST: ${seller?.gstnumber || ""}`;
  const phoneText = `Ph: ${documentConfig?.fromData?.phone
            ? `${documentConfig.fromData.phone}`
            : ""
        }${
          documentConfig?.fromData?.additionalPhone
            ? `, ${documentConfig.fromData.additionalPhone}`
            : ""
        }`;

  const horizontalPadding = 12;
  const leftStart = horizontalPadding;
  const rightEnd = pageWidth - horizontalPadding;

  doc.text(gstText, leftStart, y, { align: "left" });
  doc.text(phoneText, rightEnd, y, { align: "right" });
  y += 10;

  const fassiTest = `FASSI: ${seller?.fssai || ""}`;
  const panTex = `PAN: ${seller?.pannumber || ""}`;

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
  {
    seller?.fssai && doc.text(fassiTest, rightEnd, y, { align: "right" });
  }
  doc.text(panTex, leftStart, y, { align: "left" });
  y += 10;

  const cinTest = `CIN: ${seller?.cinnumber || ""}`;

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
  {
    seller?.cinnumber && doc.text(cinTest, leftStart, y, { align: "left" });
  }

  const storeBoxPadding = 4;

  doc.setLineWidth(1);
  doc.setLineDash([1, 1]); // solid border

  y += 14;
  const invoiceTitle =
    data?.status === "CANCELLED"
      ? "CANCELLED TAX INVOICE"
      :documentConfig?.title;


  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(14);
  const textWidth = doc.getTextWidth(invoiceTitle);
  const gap = 8; // Space between the line and the text
  margin = 10;
  // 5. Draw the Lines
  let centerX = pageWidth / 2;
  doc.text(invoiceTitle, centerX, y, { align: "center" });
  doc.setLineWidth(1);
  doc.setLineDash([3, 3]); // Use [0] for a solid line, [2, 2] for dashed like your image

  // Left Line: starts at margin, ends just before the text
  doc.line(margin, y - 4, centerX - textWidth / 2 - gap, y - 4);

  // Right Line: starts just after the text, ends at margin
  doc.line(centerX + textWidth / 2 + gap, y - 4, pageWidth - margin, y - 4);

  // 6. Reset Dash and move Y
  doc.setLineDash([]);
  y += 15;

  const { date, time } = documentConfig?.Date
  const lineHeight = 14; // Adjusted for tighter spacing seen in UI
  const leftColX = 8; // Left margin
  const rightColX = pageWidth / 2 + 10; // Start of the second column
  const drawField = (label, value, xPos, yPos) => {
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    const fieldText = `${label} : ${value}`;
    doc.text(fieldText, xPos, yPos);
  };
  drawField(
    documentConfig?.numberLabel ,
    `${documentConfig?.number}`,
    leftColX,
    y,
  );
  // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
  y += lineHeight;

  // Row 2: Date
  drawField("Date", `${date}, ${time}`, leftColX, y);
  y += lineHeight;

  // Row 3: Cashier
  // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

  const labelX = 8; // Left-aligned label start
  const colonX = 110; // Colon aligned at this point
  const valueX = 120; // Value starts after colon

  // y += 12;

  const buyer = documentConfig?.toData;
  const hasBuyerInfo =
    buyer &&
    (buyer?.name ||
      buyer?.phone ||
      buyer?.addressline1 ||
      buyer?.email ||
      buyer?.gstnumber ||
      buyer?.pannumber ||
      buyer?.cinnumber);

  // --- BUYER INFORMATION SECTION ---
  if (hasBuyerInfo) {
    // 1. Section Header: Clean and Centered
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
    y += 13;

    const leftMargin = 10;
    const lineHeight = 9;

    // 2. Buyer Name: Bold and Uppercase for Impact
    if (buyer.name) {
      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(9);
      doc.text(buyer.name.toUpperCase(), leftMargin, y);
      y += lineHeight;
    }

    // 3. Buyer Details: Smaller and Regular font
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);

    // Contact Row (Phone & Email)
    if (buyer.phone || buyer.email) {
      const contactLine = [
        buyer.phone ? `Ph: ${buyer.phone}` : null,
        buyer.email ? `Email: ${buyer.email}` : null,
      ]
        .filter(Boolean)
        .join(" | ");

      doc.text(contactLine, leftMargin, y);
      y += lineHeight;
    }

    // Address: Handling long text with splitTextToSize
    const addressParts = [
      buyer.addressline1,
      [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
      buyer.pincode ? `- ${buyer.pincode}` : null,
    ]
      .filter(Boolean)
      .join(", ");

    if (addressParts) {
      const splitAddress = doc.splitTextToSize(addressParts, pageWidth - 20);
      splitAddress.forEach((line) => {
        doc.text(line, leftMargin, y);
        y += lineHeight;
      });
    }

    // 4. Statutory IDs (GST, PAN, CIN): Compact layout
    const idList = [
      { label: "GST: ", value: buyer.gstnumber, bold: true,},      
      { label: "PAN: ", value: buyer.pannumber ,bold: true,},
      { label: "CIN: ", value: buyer.cinnumber,bold: true, },
      { label: "FSSAI: ", value: buyer.fssai,bold: true, },
      { label: "Reference No: ", value: buyer.referenceid, bold: false, },
    ];
    idList.forEach((item) => {
      if (item.value) {
        const leftMargin = 10;
     if (item.bold) {
      doc.setFont("NotoSansMono-Bold", "bold");
      } else {
        doc.setFont("NotoSansMono-Regular", "normal");
      }      
        doc.setFontSize(9);
        doc.text(item.label, leftMargin, y);

        // 2. Calculate label width so the value starts exactly after it
        const labelWidth = doc.getTextWidth(item.label);

        // 3. Draw the Value in REGULAR
        doc.setFont("NotoSansMono-Regular", "normal");
        doc.text(`${item.value}`, leftMargin + labelWidth, y);

        // 4. Move to next line
        y += 9;
      }
    });

    y += 5; // Extra spacing before the items table starts
  }

  // Define table boundaries
  const tableMargin = 8;
  const tableWidth = pageWidth - tableMargin * 2;

  autoTable(doc, {
    startY: y,
    margin: { left: tableMargin, right: tableMargin },
    theme: "plain",
    // 1. Set global border styles
    styles: {
      fontSize: 10,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black", // Light gray border
      lineWidth: 1,
      font: "NotoSansMono-Regular",
    },
    head: [
      // Header Row 1: "Items" label span
      [
        {
          content: "Items",
          colSpan: 3,
          styles: {
            halign: "left",
            fontStyle: "bold",
            lineWidth: { left: 1, right: 1, top: 1, bottom: 0 },
          },
        },
      ],
      // Header Row 2: Rate, Qty, Total
      [
        {
          content: "Rate",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { left: 1, top: 0, bottom: 1 },
          },
        },
        {
          content: "Qty",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { top: 0, bottom: 1 },
          },
        },
        {
          content: "Total",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { right: 1, top: 0, bottom: 1 },
          },
        },
      ],
    ],
    body: documentConfig?.items.flatMap((item) => [
      // Line 1: Item Name (Full width)
      [
        {
          content: item.title + (item.note ? ` (${item.note})` : ""),
          colSpan: 3,
          styles: {
            halign: "left",
            lineWidth: { left: 1, right: 1, top: 0, bottom: 0 },
          },
        },
      ],
      // Line 2: Values (Rate, Qty, Total)
      [
        {
          content: `${item.soldprice}`,
          styles: {
            halign: "center",
            lineWidth: { left: 1, top: 0, bottom: 0 },
          },
        },
        {
          content: `${item?.quantity} ${(() => {
            const unitCode = item?.isSecondaryUnit
              ? item?.unitConfig?.secondaryUnitCode
              : item?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
        },
        {
          content: `${item.lineTotalSoldPrice}`,
          styles: {
            halign: "center",
            lineWidth: { right: 1, top: 0, bottom: 0 },
          },
        },
      ],
    ]),
    // 3. Close the bottom border on the last row
    didDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) {
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Set dimensions for the boxes
  const boxPadding = 8;
  let boxWidth = (pageWidth - 24) / 2; // Split page width minus margins
  const boxHeight = 45; // Height to accommodate two lines of text
  const startX = 8;
  const rightBoxX = startX + boxWidth + 8;

  // --- 1. Draw Left Box (Qty & Items) ---
  doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
  doc.setLineWidth(1); // Light gray border
  doc.roundedRect(startX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(12);
  // Qty Line
  // doc.text("Qty :", startX + 5, y + 18);
  // doc.text(`${data.totalqty || 0}`, startX + boxWidth - 5, y + 18, { align: "right" });
  // Items Line
  doc.text("Items :", startX + 5, y + 25);
  doc.text(`${data?.totalItems}`, startX + boxWidth - 5, y + 25, {
    align: "right",
  });

  // --- 2. Draw Right Box (Total Amount) ---
  doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(12);
  const totalLabel = "Grand Total";
  const totalValue = `${documentConfig?.grandTotal}`; // Assuming raw number as per UI
  const boxCenterX = rightBoxX + boxWidth / 2;

  // Draw Label: Centered horizontally
  doc.text(totalLabel, boxCenterX, y + 18, { align: "center" });

  doc.setFontSize(13);
  doc.text(totalValue, boxCenterX, y + 38, { align: "center" });

  // // Center the content within the right box
  // const combinedText = `${totalLabel} ${totalValue}`;
  // const textWidth1 = doc.getTextWidth(combinedText);
  // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

  // doc.text(totalLabel, textStartX, y + 26);
  // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

  y += boxHeight + 10; // Advance Y position for next section

  y = checkPageBreak(doc, y);
  const boxMargin = 8;
  // 1. Prepare payment list (Only show modes with value)
  const payments = [
    { label: "Cash", amount: documentConfig?.cashPaid },
    { label: "Card", amount: documentConfig?.cardPaid },
    { label: "Online Pay", amount: documentConfig?.onlinePaid },
    { label: "UPI", amount: documentConfig?.upiPaid },
    { label: "Balance Due", amount: documentConfig?.balanceDue },
  ].filter((p) =>Math.abs(parseAmount(p.amount)) > 0);

  autoTable(doc, {
    startY: y,
    theme: "plain",
    margin: { left: boxMargin, right: boxMargin },
    styles: {
      font: "NotoSansMono-Regular",
      fontSize: 9,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black",
      lineWidth: 1,
    },
    head:hasPayment
    ?  [
      [
        {
          content: "PAYMENT MODE",
          colSpan: 3,
          styles: {
            font: "NotoSansMono-Bold",
            fontSize: 9,
            cellPadding: 1,
            fontStyle: "bold",
            lineWidth: { top: 1, left: 1, right: 1, bottom: 1 },
          },
        },
      ],
    ]:[],
    body: [
     ...(hasPayment
      ?payments.map((p) => [
        { content: p.label, styles: { fontSize: 9, lineWidth: { left: 1 } } },
        { content: ":", styles: { halign: "center", lineWidth: 0 } },
        {
          content: `${p.amount}`,
          styles: { halign: "right", lineWidth: { right: 1 }, fontSize: 9 },
        },
      ]):[]),
      // Bottom Right Footer for Tender and Balance
      [
        {
          // content: `Tender: ${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
          content: `Grand Total:   ${documentConfig?.grandTotal}`,
          colSpan: 5,
          styles: {
            halign: "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            fontSize: 12,
            cellPadding: 2,
            lineWidth: { left: 1, right: 1, bottom: 1, top: 1 },
          },
        },
      ],
    ],
    columnStyles: {
      0: { cellWidth: "auto" },
      1: { cellWidth: "20" },
      2: { cellWidth: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 15;

  // ---------- TAX TABLE SECTION (FULL) ----------

  // 1. Build Tax Head
  const taxHead = isIGST
    ? [["Tax", "Amount", "IGST"]]
    : [["Tax", "Amount", "SGST", "CGST"]];

  // 2. Build Tax Body
  const taxBody = Object.entries(taxRows)
    .filter(([percent]) => parseFloat(percent) > 0)
    .map(([percent, t]) =>
      isIGST
        ? [`${percent}%`, `${t.basePrice}`, `${t.igst}`]
        : [`${percent}%`, `${t.basePrice}`, `${t.sgst}`, `${t.cgst}`],
    );

  // 3. Render Table Only If Tax Exists
  if (taxBody.length > 0) {
    const tableMargin = 8;

    autoTable(doc, {
      startY: y,
      margin: { left: tableMargin, right: tableMargin },
      theme: "plain",

      styles: {
        fontSize: 9,
        cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
        lineColor: "black",
        lineWidth: 0,
        font: "NotoSansMono-Regular",
        fontStyle: "normal",
      },

      // 4. Dynamic Head
      head: taxHead.map((row) =>
        row.map((cell, colIndex) => ({
          content: cell,
          styles: {
            halign: colIndex === 0 ? "left" : "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            lineWidth: {
              top: 1,
              bottom: 0,
              left: colIndex === 0 ? 1 : 0,
              right: colIndex === row.length - 1 ? 1 : 0,
            },
          },
        })),
      ),

      // 5. Dynamic Body
      body: taxBody.map((row) =>
        row.map((cell, colIndex) => ({
          content: cell,
          styles: {
            halign: colIndex === 0 ? "left" : "right",
            lineWidth: {
              left: colIndex === 0 ? 1 : 0,
              right: colIndex === row.length - 1 ? 1 : 0,
              top: 0,
              bottom: 0,
            },
          },
        })),
      ),

      // 6. Draw Bottom Border for Last Row
      didDrawCell: (data) => {
        if (
          data.row.section === "body" &&
          data.row.index === data.table.body.length - 1
        ) {
          doc.setDrawColor(0);
          doc.setLineWidth(1);
          doc.line(
            data.cell.x,
            data.cell.y + data.cell.height,
            data.cell.x + data.cell.width,
            data.cell.y + data.cell.height,
          );
        }
      },
    });

    // 7. Move Y After Tax Table
    y = doc.lastAutoTable.finalY + 10;
  }
  y = checkPageBreak(doc, y);
  if (parseAmount(documentConfig?.totalDiscount) > 0) {
    const boxMargin = 8;
    const boxHeight = 20;
    const boxWidth = pageWidth - boxMargin * 2;
    // o 1
    // 1. Draw the Container Box
    doc.setDrawColor(0); // Light Gray border
    doc.setLineWidth(1);
    doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

    // 2. Set Font for the content
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);

    const savedAmount = `${documentConfig?.totalDiscount}`;
    doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + 4, y + 14);

    // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

    y += boxHeight + 10;
  }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);

  y += 10;
  doc.setFontSize(10);
  doc.text("Thank you for your purchase!", pageWidth / 2, y, {
    align: "center",
  });
  y += 11;
  doc.setFont("NotoSansMono-Bold", "bold");
  doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
  const thankBoxPadding = 10;
  y += 11;

  doc.setFont("NotoSansMono-Regular", "normal");
  doc.text("Powered By", pageWidth / 2, y, { align: "center" });
  y += 11;
  doc.setFontSize(9);
  const sitePrefix = "www.";
  const siteBold = "NegoBill";
  const siteSuffix = ".com";
  const prefixWidth = doc.getTextWidth(sitePrefix);
  const boldWidth = doc.getTextWidth(siteBold);
  const suffixWidth = doc.getTextWidth(siteSuffix);
  const totalWidth = prefixWidth + boldWidth + suffixWidth;
  const startX1 = (pageWidth - totalWidth) / 2;
  if (storeSettings?.negobillBranding) {
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(sitePrefix, startX1, y);
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text(siteBold, startX1 + prefixWidth, y);
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
    y += 10;
  }
  // setPrint(false);
  return doc;
};

export const Browser3InchBillReceiptM2 = async (
   data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings
) => {
  const {
    documentConfig,  hasPayment     
  } = invoiceConfig;
  const doc = new jsPDF({
    unit: "pt",
    format: [204, 1000],
  });
  const pageWidth = doc.internal.pageSize.getWidth();

  let y = 10;

  const isIGST =
    documentConfig?.fromData?.statecode &&
    documentConfig?.toData?.statecode &&
    documentConfig?.fromData.statecode !== documentConfig?.toData.statecode;

  const taxRows = documentConfig?.items?.reduce((acc, product) => {
    const taxPercentage = product.taxpercentage || 0;
    const taxAmount = product.lineTotalTaxAmount || 0;
    const basePrice = product.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});
  const checkPageBreak = (doc, y, buffer = 20) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    if (y + buffer >= pageHeight) {
      doc.addPage();
      return 14;
    }
    return y;
  };
  // const storeBoxStartY = y;

 const imagePath =  documentConfig?.image;

  // const imagePath = settings?.saleProfileData?.image
  //   ?  settings?.saleProfileData?.image
  //   : "/assets/images/logo-light.png";

  if (documentConfig?.image) {
    try {
      // Step 1: Convert image URL to base64
      const response = await fetch(imagePath, { mode: "cors" });
      const blob = await response.blob();
      let base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      // Step 2: Convert to grayscale
      base64 = await convertToGrayScale(base64);

      // Step 3: Get natural dimensions
      const { width: naturalWidth, height: naturalHeight } =
        await loadImageDimensions(base64);

      // Step 4: Resize to fit dynamically within maxWidth and maxHeight
      const maxWidth = 80; // maximum width in pt for 3-inch receipt
      const maxHeight = 40; // maximum height in pt
      const widthRatio = maxWidth / naturalWidth;
      const heightRatio = maxHeight / naturalHeight;
      const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

      const imgWidth = naturalWidth * ratio;
      const imgHeight = naturalHeight * ratio;

      // Step 5: Center the logo
      const logoX = (pageWidth - imgWidth) / 2;

      doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

      y += imgHeight + 20; // spacing after logo
    } catch (err) {
      console.warn("Logo failed to load:", err);
    }
  }

  let margin = 15;
  const drawDashedLine = (yPos) => {
    doc.setLineDash([3, 3], 0);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    doc.setLineDash([]); // Reset to solid
  };
  // Header

  doc.setFont("NotoSansMono-Bold", "bold");

  doc.setFontSize(13);
  const storeTitle = documentConfig?.fromData?.title || "Store";
  doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
    doc.text(line, pageWidth / 2, y, { align: "center" });
    y += 13;
  });
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  const seller = documentConfig?.fromData;
  const sellerAddressParts = [
    seller?.addressline1,
    [seller?.state].filter(Boolean).join(", "),
  ].filter(Boolean);
  doc
    .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 50)
    .forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 10;
    });

  // if (seller?.email) {
  //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
  //   y += 16;
  // }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9); // Slightly smaller to match UI

  const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
  doc.text(addressText, pageWidth / 2, y, { align: "center" });
  y += 10;
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  // const gstText = `GST: ${seller?.gstnumber || ""}`;
  const phoneNumbers = [
  documentConfig?.fromData?.phone,
  documentConfig?.fromData?.additionalPhone,
].filter(Boolean);
 const phoneText = phoneNumbers.length
  ? `Ph: ${phoneNumbers.join(", ")}`
  : "";
  const cinTest = `CIN: ${seller?.cinnumber || ""}`;
  const panTex = `PAN: ${seller?.pannumber || ""}`;

  const horizontalPadding = 12;
  const leftStart = horizontalPadding;
  const rightEnd = pageWidth - horizontalPadding;

// PAN
if (seller?.pannumber) {
  doc.text(panTex, leftStart, y, {
    align: "left",
  });
}

// Phone
if (phoneText) {
  const phoneMaxWidth = pageWidth / 2 - horizontalPadding;

  const phoneLines = doc.splitTextToSize(
    phoneText,
    phoneMaxWidth
  );

  doc.text(phoneLines, rightEnd, y, {
    align: "right",
  });

  // Move down based on wrapped lines
  y += phoneLines.length * 4;
} else {
  y += 4;
}

y += 1;
  // doc.text(panTex, leftStart, y, { align: "left" });
  // doc.text(phoneText, rightEnd, y, { align: "right" });
  // y += 10;

  const fassiTest = `FASSI: ${seller?.fssai || ""}`;

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  {
    seller?.fssai && doc.text(fassiTest, leftStart, y, { align: "left" });
    y += 10;
  }

  {
    seller?.cinnumber && doc.text(cinTest, leftStart, y, { align: "left" });
  }

  y += 5;

  const storeBoxPadding = 4;

  doc.setLineWidth(1);
  doc.setLineDash([1, 1]); // solid border

  y += 8;
  const invoiceTitle =
    data?.status === "CANCELLED"
      ? "CANCELLED TAX INVOICE"
      :documentConfig?.title;

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(11);
  const textWidth = doc.getTextWidth(invoiceTitle);
  const gap = 8; // Space between the line and the text
  margin = 10;
  // 5. Draw the Lines
  let centerX = pageWidth / 2;
  doc.text(invoiceTitle, centerX, y, { align: "center" });
  doc.setLineWidth(1);
  doc.setLineDash([3, 3]); // Use [0] for a solid line, [2, 2] for dashed like your image

  // Left Line: starts at margin, ends just before the text
  doc.line(margin, y - 4, centerX - textWidth / 2 - gap, y - 4);

  // Right Line: starts just after the text, ends at margin
  doc.line(centerX + textWidth / 2 + gap, y - 4, pageWidth - margin, y - 4);

  // 6. Reset Dash and move Y
  doc.setLineDash([]);
  y += 15;

  const { date, time } = documentConfig?.Date
  const lineHeight = 13; // Adjusted for tighter spacing seen in UI
  const leftColX = 8; // Left margin
  const rightColX = pageWidth / 2 + 10; // Start of the second column
  const drawField = (label, value, xPos, yPos) => {
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    const fieldText = `${label} : ${value}`;
    doc.text(fieldText, xPos, yPos);
  };
  drawField(documentConfig?.numberLabel, `${documentConfig?.number}`, leftColX, y);
  // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
  y += lineHeight;

  // Row 2: Date
  drawField("Date", `${date}, ${time}`, leftColX, y);
  y += lineHeight;

  // Row 3: Cashier
  // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

  const labelX = 8; // Left-aligned label start
  const colonX = 110; // Colon aligned at this point
  const valueX = 120; // Value starts after colon

  // y += 12;
  const buyer = documentConfig?.toData;
  const hasBuyerInfo =
    buyer &&
    (buyer?.name ||
      buyer?.phone ||
      buyer?.addressline1 ||
      buyer?.email ||
      buyer?.gstnumber ||
      buyer?.pannumber ||
      buyer?.cinnumber);

  if (hasBuyerInfo) {
    // 1. Section Header: Clean and Centered
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
    y += 13;

    const leftMargin = 10;
    const lineHeight = 16;

    // 2. Buyer Name: Bold and Uppercase for Impact
    if (buyer.name) {
      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(9);
      doc.text(buyer.name.toUpperCase(), leftMargin, y);
      y += lineHeight;
    }

    // 3. Buyer Details: Smaller and Regular font
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);

    // Contact Row (Phone & Email)
    if (buyer.phone || buyer.email) {
      const contactLine = [
        buyer.phone ? `Ph: ${buyer.phone}` : null,
        buyer.email ? `Email: ${buyer.email}` : null,
      ]
        .filter(Boolean)
        .join(" | ");

      doc.text(contactLine, leftMargin, y);
      y += lineHeight;
    }

    // Address: Handling long text with splitTextToSize
    const addressParts = [
      buyer.addressline1,
      [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
      buyer.pincode ? `- ${buyer.pincode}` : null,
    ]
      .filter(Boolean)
      .join(", ");

    if (addressParts) {
      const splitAddress = doc.splitTextToSize(addressParts, pageWidth - 20);
      splitAddress.forEach((line) => {
        doc.text(line, leftMargin, y);
        y += lineHeight;
      });
    }

    // 4. Statutory IDs (GST, PAN, CIN): Compact layout
    const idList = [
      { label: "GST: ", value: buyer.gstnumber, bold: true,},      
      { label: "PAN: ", value: buyer.pannumber ,bold: true,},
      { label: "CIN: ", value: buyer.cinnumber,bold: true, },
      { label: "FSSAI: ", value: buyer.fssai,bold: true, },
      { label: "Reference No: ", value: buyer.referenceid, bold: false, },
    ];
    idList.forEach((item) => {
      if (item.value) {
        const leftMargin = 10;

        // 1. Draw the Label in BOLD
          if (item.bold) {
      doc.setFont("NotoSansMono-Bold", "bold");
    } else {
      doc.setFont("NotoSansMono-Regular", "normal");
    }
        doc.setFontSize(9);
        doc.text(item.label, leftMargin, y);

        // 2. Calculate label width so the value starts exactly after it
        const labelWidth = doc.getTextWidth(item.label);

        // 3. Draw the Value in REGULAR
        doc.setFont("NotoSansMono-Regular", "normal");
        doc.text(`${item.value}`, leftMargin + labelWidth, y);

        // 4. Move to next line
        y += 14;
      }
    });

    y += 5; // Extra spacing before the items table starts
  }

  const tableMargin = 8;
  const tableWidth = pageWidth - tableMargin * 2;

  autoTable(doc, {
    startY: y,
    margin: { left: tableMargin, right: tableMargin },
    theme: "plain",
    // 1. Set global border styles
    styles: {
      fontSize: 10,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black", // Light gray border
      lineWidth: 1,
      font: "NotoSansMono-Regular",
    },
    head: [
      // Header Row 1: "Items" label span
      [
        {
          content: "Items",
          colSpan: 3,
          styles: {
            halign: "left",
            fontStyle: "bold",
            lineWidth: { left: 1, right: 1, top: 1, bottom: 0 },
          },
        },
      ],
      // Header Row 2: Rate, Qty, Total
      [
        {
          content: "Rate",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { left: 1, top: 0, bottom: 1 },
          },
        },
        {
          content: "Qty",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { top: 0, bottom: 1 },
          },
        },
        {
          content: "Total",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { right: 1, top: 0, bottom: 1 },
          },
        },
      ],
    ],
    body: documentConfig?.items.flatMap((item) => [
      // Line 1: Item Name (Full width)
      [
        {
          content: item.title + (item.note ? ` (${item.note})` : ""),
          colSpan: 3,
          styles: {
            halign: "left",
            lineWidth: { left: 1, right: 1, top: 0, bottom: 0 },
          },
        },
      ],
      // Line 2: Values (Rate, Qty, Total)
      [
        {
          content: `${item.soldprice}`,
          styles: {
            halign: "center",
            lineWidth: { left: 1, top: 0, bottom: 0 },
          },
        },
        {
          content: `${item?.quantity} ${(() => {
            const unitCode = item?.isSecondaryUnit
              ? item?.unitConfig?.secondaryUnitCode
              : item?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
        },
        {
          content: `${item.lineTotalSoldPrice}`,
          styles: {
            halign: "center",
            lineWidth: { right: 1, top: 0, bottom: 0 },
          },
        },
      ],
    ]),
    // 3. Close the bottom border on the last row
    didDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) {
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Set dimensions for the boxes
  const boxPadding = 8;
  let boxWidth = (pageWidth - 24) / 2; // Split page width minus margins
  const boxHeight = 45; // Height to accommodate two lines of text
  const startX = 8;
  const rightBoxX = startX + boxWidth + 8;

  // --- 1. Draw Left Box (Qty & Items) ---
  doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
  doc.setLineWidth(1); // Light gray border
  doc.roundedRect(startX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(12);
  // Qty Line
  // doc.text("Qty :", startX + 5, y + 18);
  // doc.text(`${data.totalqty || 0}`, startX + boxWidth - 5, y + 18, { align: "right" });
  // Items Line
  doc.text("Items :", startX + 5, y + 25);
  doc.text(`${data?.totalItems}`, startX + boxWidth - 5, y + 25, {
    align: "right",
  });

  // --- 2. Draw Right Box (Total Amount) ---
  doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(12);
  const totalLabel = "Grand Total";
  const totalValue = `${documentConfig?.grandTotal}`; // Assuming raw number as per UI
  const boxCenterX = rightBoxX + boxWidth / 2;

  // Draw Label: Centered horizontally
  doc.text(totalLabel, boxCenterX, y + 18, { align: "center" });

  doc.setFontSize(13);
  doc.text(totalValue, boxCenterX, y + 38, { align: "center" });

  // // Center the content within the right box
  // const combinedText = `${totalLabel} ${totalValue}`;
  // const textWidth1 = doc.getTextWidth(combinedText);
  // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

  // doc.text(totalLabel, textStartX, y + 26);
  // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

  y += boxHeight + 10; // Advance Y position for next section

  y = checkPageBreak(doc, y);
  const boxMargin = 8;
  // 1. Prepare payment list (Only show modes with value)
  const payments = [
    { label: "Cash", amount: documentConfig?.cashPaid },
    { label: "Card", amount: documentConfig?.cardPaid },
    { label: "Online Pay", amount: documentConfig?.onlinePaid },
    { label: "UPI", amount: documentConfig?.upiPaid },
    { label: "Balance Due", amount: documentConfig?.balanceDue },
  ].filter((p) => Math.abs(parseAmount(p.amount)) > 0);

  autoTable(doc, {
    startY: y,
    theme: "plain",
    margin: { left: boxMargin, right: boxMargin },
    styles: {
      font: "NotoSansMono-Regular",
      fontSize: 9,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black",
      lineWidth: 1,
    },
    head:hasPayment
    ? [
      [
        {
          content: "PAYMENT MODE",
          colSpan: 3,
          styles: {
            font: "NotoSansMono-Bold",
            fontSize: 9,
            cellPadding: 1,
            fontStyle: "bold",
            lineWidth: { top: 1, left: 1, right: 1, bottom: 1 },
          },
        },
      ],
    ]:[],
    body: [
      ...(hasPayment
      ?payments.map((p) => [
        { content: p.label, styles: { fontSize: 9, lineWidth: { left: 1 } } },
        { content: ":", styles: { halign: "center", lineWidth: 0 } },
        {
          content: `${p.amount}`,
          styles: { halign: "right", lineWidth: { right: 1 }, fontSize: 9 },
        },
      ]):[]),
      // Bottom Right Footer for Tender and Balance
      [
        {
          // content: `Tender: ${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
          content: `Grand Total:   ${documentConfig?.grandTotal}`,
          colSpan: 5,
          styles: {
            halign: "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            fontSize: 12,
            cellPadding: 2,
            lineWidth: { left: 1, right: 1, bottom: 1, top: 1 },
          },
        },
      ],
    ],
    columnStyles: {
      0: { cellWidth: "auto" },
      1: { cellWidth: "20" },
      2: { cellWidth: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 15;

  y = checkPageBreak(doc, y);
  if (parseAmount(documentConfig?.totalDiscount) > 0) {
    const boxMargin = 8;
    const boxHeight = 20;
    const boxWidth = pageWidth - boxMargin * 2;
    // o 1
    // 1. Draw the Container Box
    doc.setDrawColor(0); // Light Gray border
    doc.setLineWidth(1);
    doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

    // 2. Set Font for the content
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);

    const savedAmount = `${documentConfig?.totalDiscount}`;
    doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + 4, y + 14);

    // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

    y += boxHeight + 10;
  }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);

  y += 5;
  doc.setFontSize(8);
  doc.text("Thank you for your purchase!", pageWidth / 2, y, {
    align: "center",
  });
  y += 10;
  doc.setFont("NotoSansMono-Bold", "bold");
  doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
  const thankBoxPadding = 10;
  y += 10;

  doc.setFont("NotoSansMono-Regular", "normal");
  doc.text("Powered By", pageWidth / 2, y, { align: "center" });
  y += 10;
  doc.setFontSize(8);
  const sitePrefix = "www.";
  const siteBold = "NegoBill";
  const siteSuffix = ".com";
  const prefixWidth = doc.getTextWidth(sitePrefix);
  const boldWidth = doc.getTextWidth(siteBold);
  const suffixWidth = doc.getTextWidth(siteSuffix);
  const totalWidth = prefixWidth + boldWidth + suffixWidth;
  const startX1 = (pageWidth - totalWidth) / 2;
  if (storeSettings?.negobillBranding) {
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(sitePrefix, startX1, y);
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text(siteBold, startX1 + prefixWidth, y);
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
  }
  y += 10;
  // setPrint(false);
  return doc;
};

export const Browser3InchInvoiceReceiptM2 = async (
   data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings
) => {
  const {
    documentConfig, hasPayment      
  } = invoiceConfig;
  const doc = new jsPDF({
    unit: "pt",
    format: [204, 1000],
  });
  const pageWidth = doc.internal.pageSize.getWidth();

  let y = 10;

  const isIGST =
    documentConfig?.fromData?.statecode &&
    documentConfig?.toData?.statecode &&
    documentConfig?.fromData.statecode !== documentConfig?.toData.statecode;

  const taxRows = documentConfig?.items?.reduce((acc, product) => {
    const taxPercentage = product.taxpercentage || 0;
    const taxAmount = product.lineTotalTaxAmount || 0;
    const basePrice = product.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});
  const checkPageBreak = (doc, y, buffer = 20) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    if (y + buffer >= pageHeight) {
      doc.addPage();
      return 14;
    }
    return y;
  };
  // const storeBoxStartY = y;

 const imagePath =  documentConfig?.image;

  // const imagePath = settings?.saleProfileData?.image
  //   ?  settings?.saleProfileData?.image
  //   : "/assets/images/logo-light.png";

  if (documentConfig?.image) {
    try {
      // Step 1: Convert image URL to base64
      const response = await fetch(imagePath, { mode: "cors" });
      const blob = await response.blob();
      let base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      // Step 2: Convert to grayscale
      base64 = await convertToGrayScale(base64);

      // Step 3: Get natural dimensions
      const { width: naturalWidth, height: naturalHeight } =
        await loadImageDimensions(base64);

      // Step 4: Resize to fit dynamically within maxWidth and maxHeight
      const maxWidth = 80; // maximum width in pt for 3-inch receipt
      const maxHeight = 40; // maximum height in pt
      const widthRatio = maxWidth / naturalWidth;
      const heightRatio = maxHeight / naturalHeight;
      const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

      const imgWidth = naturalWidth * ratio;
      const imgHeight = naturalHeight * ratio;

      // Step 5: Center the logo
      const logoX = (pageWidth - imgWidth) / 2;

      doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

      y += imgHeight + 20; // spacing after logo
    } catch (err) {
      console.warn("Logo failed to load:", err);
    }
  }

  let margin = 15;
  const drawDashedLine = (yPos) => {
    doc.setLineDash([3, 3], 0);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    doc.setLineDash([]); // Reset to solid
  };
  // Header

  doc.setFont("NotoSansMono-Bold", "bold");

  doc.setFontSize(13);
  const storeTitle = documentConfig?.fromData?.title || "Store";
  doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
    doc.text(line, pageWidth / 2, y, { align: "center" });
    y += 13;
  });
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  const seller = documentConfig?.fromData;
  const sellerAddressParts = [
    seller?.addressline1,
    [seller?.state].filter(Boolean).join(", "),
  ].filter(Boolean);
  doc
    .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 50)
    .forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 9;
    });

  // if (seller?.email) {
  //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
  //   y += 16;
  // }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9); // Slightly smaller to match UI

  const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
  doc.text(addressText, pageWidth / 2, y, { align: "center" });
  y += 10;
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);
  const phoneNumbers = [
  documentConfig?.fromData?.phone,
  documentConfig?.fromData?.additionalPhone,
].filter(Boolean);

if (phoneNumbers.length > 0) {
  const phoneText = `Ph: ${phoneNumbers.join(", ")}`;

  doc
    .setFont("NotoSansMono-Regular", "normal")
    .setFontSize(9);

  // Separate row - no wrapping
  doc.text(phoneText, pageWidth / 2, y, {
    align: "center",
  });

  y += 10;
}

  const gstText = `GST: ${seller?.gstnumber || ""}`; 
  const horizontalPadding = 12;
  const leftStart = horizontalPadding;
  const rightEnd = pageWidth - horizontalPadding;

  doc.text(gstText, leftStart, y, { align: "left" });  
  y += 13;

 const fassiTest = seller?.fssai
  ? `FASSI: ${seller.fssai}`
  : "";

const panTex = seller?.pannumber
  ? `PAN: ${seller.pannumber}`
  : "";

doc
  .setFont("NotoSansMono-Regular", "normal")
  .setFontSize(10);
// PAN - left
if (panTex) {
  doc.text(panTex, leftStart, y, {
    align: "left",
  });
}
// FASSI - right
if (fassiTest) {
  const fassiMaxWidth = pageWidth / 2 - 14;

  const fassiLines = doc.splitTextToSize(
    fassiTest,
    fassiMaxWidth
  );

  doc.text(fassiLines, rightEnd, y, {
    align: "right",
  });

  // Move down only when FASSI actually wraps
  if (fassiLines.length > 1) {
    y += (fassiLines.length - 1) * 4;
  }
}

y += 10;

  const cinTest = `CIN: ${seller?.cinnumber || ""}`;

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
  {
    seller?.cinnumber && doc.text(cinTest, leftStart, y, { align: "left" });
  }

  const storeBoxPadding = 4;

  doc.setLineWidth(1);
  doc.setLineDash([1, 1]); // solid border

  y += 14;
  const invoiceTitle =
    data?.status === "CANCELLED"
      ? "CANCELLED TAX INVOICE"
      :documentConfig?.title;

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(14);
  const textWidth = doc.getTextWidth(invoiceTitle);
  const gap = 8; // Space between the line and the text
  margin = 10;
  // 5. Draw the Lines
  let centerX = pageWidth / 2;
  doc.text(invoiceTitle, centerX, y, { align: "center" });
  doc.setLineWidth(1);
  doc.setLineDash([3, 3]); // Use [0] for a solid line, [2, 2] for dashed like your image

  // Left Line: starts at margin, ends just before the text
  doc.line(margin, y - 4, centerX - textWidth / 2 - gap, y - 4);

  // Right Line: starts just after the text, ends at margin
  doc.line(centerX + textWidth / 2 + gap, y - 4, pageWidth - margin, y - 4);

  // 6. Reset Dash and move Y
  doc.setLineDash([]);
  y += 15;

  const { date, time } = documentConfig?.Date
  const lineHeight = 14; // Adjusted for tighter spacing seen in UI
  const leftColX = 8; // Left margin
  const rightColX = pageWidth / 2 + 10; // Start of the second column
  const drawField = (label, value, xPos, yPos) => {
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    const fieldText = `${label} : ${value}`;
    doc.text(fieldText, xPos, yPos);
  };
  drawField(
    documentConfig?.numberLabel ,
    `${documentConfig?.number}`,
    leftColX,
    y,
  );
  // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
  y += lineHeight;

  // Row 2: Date
  drawField("Date", `${date}, ${time}`, leftColX, y);
  y += lineHeight;

  // Row 3: Cashier
  // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

  const labelX = 8; // Left-aligned label start
  const colonX = 110; // Colon aligned at this point
  const valueX = 120; // Value starts after colon

  // y += 12;

  const buyer = documentConfig?.toData;
  const hasBuyerInfo =
    buyer &&
    (buyer?.name ||
      buyer?.phone ||
      buyer?.addressline1 ||
      buyer?.email ||
      buyer?.gstnumber ||
      buyer?.pannumber ||
      buyer?.cinnumber);

  // --- BUYER INFORMATION SECTION ---
  if (hasBuyerInfo) {
    // 1. Section Header: Clean and Centered
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);
    doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
    y += 13;

    const leftMargin = 10;
    const lineHeight = 9;

    // 2. Buyer Name: Bold and Uppercase for Impact
    if (buyer.name) {
      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(9);
      doc.text(buyer.name.toUpperCase(), leftMargin, y);
      y += lineHeight;
    }

    // 3. Buyer Details: Smaller and Regular font
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(9);

    // Contact Row (Phone & Email)
    if (buyer.phone || buyer.email) {
      const contactLine = [
        buyer.phone ? `Ph: ${buyer.phone}` : null,
        buyer.email ? `Email: ${buyer.email}` : null,
      ]
        .filter(Boolean)
        .join(" | ");

      doc.text(contactLine, leftMargin, y);
      y += lineHeight;
    }

    // Address: Handling long text with splitTextToSize
    const addressParts = [
      buyer.addressline1,
      [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
      buyer.pincode ? `- ${buyer.pincode}` : null,
    ]
      .filter(Boolean)
      .join(", ");

    if (addressParts) {
      const splitAddress = doc.splitTextToSize(addressParts, pageWidth - 20);
      splitAddress.forEach((line) => {
        doc.text(line, leftMargin, y);
        y += lineHeight;
      });
    }

    // 4. Statutory IDs (GST, PAN, CIN): Compact layout
     const idList = [
      { label: "GST: ", value: buyer.gstnumber, bold: true,},      
      { label: "PAN: ", value: buyer.pannumber ,bold: true,},
      { label: "CIN: ", value: buyer.cinnumber,bold: true, },
      { label: "FSSAI: ", value: buyer.fssai,bold: true, },
      { label: "Reference No: ", value: buyer.referenceid, bold: false, },
    ];
    idList.forEach((item) => {
      if (item.value) {
        const leftMargin = 10;
  if (item.bold) {
      doc.setFont("NotoSansMono-Bold", "bold");
    } else {
      doc.setFont("NotoSansMono-Regular", "normal");
    }
        // 1. Draw the Label in BOLD
        doc.setFontSize(9);
        doc.text(item.label, leftMargin, y);

        // 2. Calculate label width so the value starts exactly after it
        const labelWidth = doc.getTextWidth(item.label);

        // 3. Draw the Value in REGULAR
        doc.setFont("NotoSansMono-Regular", "normal");
        doc.text(`${item.value}`, leftMargin + labelWidth, y);

        // 4. Move to next line
        y += 9;
      }
    });

    y += 5; // Extra spacing before the items table starts
  }

  // Define table boundaries
  const tableMargin = 8;
  const tableWidth = pageWidth - tableMargin * 2;

  autoTable(doc, {
    startY: y,
    margin: { left: tableMargin, right: tableMargin },
    theme: "plain",
    // 1. Set global border styles
    styles: {
      fontSize: 10,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black", // Light gray border
      lineWidth: 1,
      font: "NotoSansMono-Regular",
    },
    head: [
      // Header Row 1: "Items" label span
      [
        {
          content: "Items",
          colSpan: 3,
          styles: {
            halign: "left",
            fontStyle: "bold",
            lineWidth: { left: 1, right: 1, top: 1, bottom: 0 },
          },
        },
      ],
      // Header Row 2: Rate, Qty, Total
      [
        {
          content: "Rate",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { left: 1, top: 0, bottom: 1 },
          },
        },
        {
          content: "Qty",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { top: 0, bottom: 1 },
          },
        },
        {
          content: "Total",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { right: 1, top: 0, bottom: 1 },
          },
        },
      ],
    ],
    body: documentConfig?.items.flatMap((item) => [
      // Line 1: Item Name (Full width)
      [
        {
          content: item.title + (item.note ? ` (${item.note})` : ""),
          colSpan: 3,
          styles: {
            halign: "left",
            lineWidth: { left: 1, right: 1, top: 0, bottom: 0 },
          },
        },
      ],
      // Line 2: Values (Rate, Qty, Total)
      [
        {
          content: `${item.soldprice}`,
          styles: {
            halign: "center",
            lineWidth: { left: 1, top: 0, bottom: 0 },
          },
        },
        {
          content: `${item?.quantity} ${(() => {
            const unitCode = item?.isSecondaryUnit
              ? item?.unitConfig?.secondaryUnitCode
              : item?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
        },
        {
          content: `${item.lineTotalSoldPrice}`,
          styles: {
            halign: "center",
            lineWidth: { right: 1, top: 0, bottom: 0 },
          },
        },
      ],
    ]),
    // 3. Close the bottom border on the last row
    didDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) {
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  y = doc.lastAutoTable.finalY + 10;

  // Set dimensions for the boxes
  const boxPadding = 8;
  let boxWidth = (pageWidth - 24) / 2; // Split page width minus margins
  const boxHeight = 45; // Height to accommodate two lines of text
  const startX = 8;
  const rightBoxX = startX + boxWidth + 8;

  // --- 1. Draw Left Box (Qty & Items) ---
  doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
  doc.setLineWidth(1); // Light gray border
  doc.roundedRect(startX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(12);
  // Qty Line
  // doc.text("Qty :", startX + 5, y + 18);
  // doc.text(`${data.totalqty || 0}`, startX + boxWidth - 5, y + 18, { align: "right" });
  // Items Line
  doc.text("Items :", startX + 5, y + 25);
  doc.text(`${data?.totalItems}`, startX + boxWidth - 5, y + 25, {
    align: "right",
  });

  // --- 2. Draw Right Box (Total Amount) ---
  doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(12);
  const totalLabel = "Grand Total";
  const totalValue = `${documentConfig?.grandTotal}`; // Assuming raw number as per UI
  const boxCenterX = rightBoxX + boxWidth / 2;

  // Draw Label: Centered horizontally
  doc.text(totalLabel, boxCenterX, y + 18, { align: "center" });

  doc.setFontSize(13);
  doc.text(totalValue, boxCenterX, y + 38, { align: "center" });

  // // Center the content within the right box
  // const combinedText = `${totalLabel} ${totalValue}`;
  // const textWidth1 = doc.getTextWidth(combinedText);
  // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

  // doc.text(totalLabel, textStartX, y + 26);
  // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

  y += boxHeight + 10; // Advance Y position for next section

  y = checkPageBreak(doc, y);
  const boxMargin = 8;
  // 1. Prepare payment list (Only show modes with value)
  const payments = [
    { label: "Cash", amount: documentConfig?.cashPaid },
    { label: "Card", amount: documentConfig?.cardPaid },
    { label: "Online Pay", amount: documentConfig?.onlinePaid },
    { label: "UPI", amount: documentConfig?.upiPaid },
    { label: "Balance Due", amount: documentConfig?.balanceDue },
  ].filter((p) => Math.abs(parseAmount(p.amount)) > 0);

  autoTable(doc, {
    startY: y,
    theme: "plain",
    margin: { left: boxMargin, right: boxMargin },
    styles: {
      font: "NotoSansMono-Regular",
      fontSize: 9,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black",
      lineWidth: 1,
    },
    head:hasPayment
    ? [
      [
        {
          content: "PAYMENT MODE",
          colSpan: 3,
          styles: {
            font: "NotoSansMono-Bold",
            fontSize: 9,
            cellPadding: 1,
            fontStyle: "bold",
            lineWidth: { top: 1, left: 1, right: 1, bottom: 1 },
          },
        },
      ],
    ]:[],
    body: [
     ...(hasPayment
      ?payments.map((p) => [
        { content: p.label, styles: { fontSize: 9, lineWidth: { left: 1 } } },
        { content: ":", styles: { halign: "center", lineWidth: 0 } },
        {
          content: `${p.amount}`,
          styles: { halign: "right", lineWidth: { right: 1 }, fontSize: 9 },
        },
      ]):[]),
      // Bottom Right Footer for Tender and Balance
      [
        {
          // content: `Tender: ${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
          content: `Grand Total:   ${documentConfig?.grandTotal}`,
          colSpan: 5,
          styles: {
            halign: "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            fontSize: 12,
            cellPadding: 2,
            lineWidth: { left: 1, right: 1, bottom: 1, top: 1 },
          },
        },
      ],
    ],
    columnStyles: {
      0: { cellWidth: "auto" },
      1: { cellWidth: "20" },
      2: { cellWidth: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 15;

  // ---------- TAX TABLE SECTION (FULL) ----------

  // 1. Build Tax Head
  const taxHead = isIGST
    ? [["Tax", "Amount", "IGST"]]
    : [["Tax", "Amount", "SGST", "CGST"]];

  // 2. Build Tax Body
  const taxBody = Object.entries(taxRows)
    .filter(([percent]) => parseFloat(percent) > 0)
    .map(([percent, t]) =>
      isIGST
        ? [`${percent}%`, `${t.basePrice}`, `${t.igst}`]
        : [`${percent}%`, `${t.basePrice}`, `${t.sgst}`, `${t.cgst}`],
    );

  // 3. Render Table Only If Tax Exists
  if (taxBody.length > 0) {
    const tableMargin = 8;

    autoTable(doc, {
      startY: y,
      margin: { left: tableMargin, right: tableMargin },
      theme: "plain",

      styles: {
        fontSize: 9,
        cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
        lineColor: "black",
        lineWidth: 0,
        font: "NotoSansMono-Regular",
        fontStyle: "normal",
      },

      // 4. Dynamic Head
      head: taxHead.map((row) =>
        row.map((cell, colIndex) => ({
          content: cell,
          styles: {
            halign: colIndex === 0 ? "left" : "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            lineWidth: {
              top: 1,
              bottom: 0,
              left: colIndex === 0 ? 1 : 0,
              right: colIndex === row.length - 1 ? 1 : 0,
            },
          },
        })),
      ),

      // 5. Dynamic Body
      body: taxBody.map((row) =>
        row.map((cell, colIndex) => ({
          content: cell,
          styles: {
            halign: colIndex === 0 ? "left" : "right",
            lineWidth: {
              left: colIndex === 0 ? 1 : 0,
              right: colIndex === row.length - 1 ? 1 : 0,
              top: 0,
              bottom: 0,
            },
          },
        })),
      ),

      // 6. Draw Bottom Border for Last Row
      didDrawCell: (data) => {
        if (
          data.row.section === "body" &&
          data.row.index === data.table.body.length - 1
        ) {
          doc.setDrawColor(0);
          doc.setLineWidth(1);
          doc.line(
            data.cell.x,
            data.cell.y + data.cell.height,
            data.cell.x + data.cell.width,
            data.cell.y + data.cell.height,
          );
        }
      },
    });

    // 7. Move Y After Tax Table
    y = doc.lastAutoTable.finalY + 10;
  }
  y = checkPageBreak(doc, y);
  if (parseAmount(documentConfig?.totalDiscount) > 0) {
    const boxMargin = 8;
    const boxHeight = 20;
    const boxWidth = pageWidth - boxMargin * 2;
    // o 1
    // 1. Draw the Container Box
    doc.setDrawColor(0); // Light Gray border
    doc.setLineWidth(1);
    doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

    // 2. Set Font for the content
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);

    const savedAmount = `${documentConfig?.totalDiscount}`;
    doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + 4, y + 14);

    // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

    y += boxHeight + 10;
  }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(14);

  y += 10;
  doc.setFontSize(10);
  doc.text("Thank you for your purchase!", pageWidth / 2, y, {
    align: "center",
  });
  y += 11;
  doc.setFont("NotoSansMono-Bold", "bold");
  doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
  const thankBoxPadding = 10;
  y += 11;

  doc.setFont("NotoSansMono-Regular", "normal");
  doc.text("Powered By", pageWidth / 2, y, { align: "center" });
  y += 11;
  doc.setFontSize(9);
  const sitePrefix = "www.";
  const siteBold = "NegoBill";
  const siteSuffix = ".com";
  const prefixWidth = doc.getTextWidth(sitePrefix);
  const boldWidth = doc.getTextWidth(siteBold);
  const suffixWidth = doc.getTextWidth(siteSuffix);
  const totalWidth = prefixWidth + boldWidth + suffixWidth;
  const startX1 = (pageWidth - totalWidth) / 2;
  if (storeSettings?.negobillBranding) {
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(sitePrefix, startX1, y);
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text(siteBold, startX1 + prefixWidth, y);
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
    y += 10;
  }
  // setPrint(false);
  return doc;
};

export const Browser2InchBillReceiptM2 = async (
  data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings
) => {
  const {
    documentConfig,hasPayment       
  } = invoiceConfig;
  const doc = new jsPDF({
    unit: "pt",
    format: [144, 1000],
  });

  const pageWidth = doc.internal.pageSize.getWidth();

  let y = 10;

  const isIGST =
    documentConfig?.fromData?.statecode &&
    documentConfig?.toData?.statecode &&
    documentConfig?.fromData.statecode !== documentConfig?.toData.statecode;

  const taxRows = documentConfig?.items?.reduce((acc, product) => {
    const taxPercentage = product.taxpercentage || 0;
    const taxAmount = product.lineTotalTaxAmount || 0;
    const basePrice = product.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});
  const checkPageBreak = (doc, y, buffer = 20) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    if (y + buffer >= pageHeight) {
      doc.addPage();
      return 14;
    }
    return y;
  };
  // const storeBoxStartY = y;

 const imagePath =  documentConfig?.image;

  // const imagePath = settings?.saleProfileData?.image
  //   ?  settings?.saleProfileData?.image
  //   : "/assets/images/logo-light.png";

  if (documentConfig?.image) {
    try {
      // Step 1: Convert image URL to base64
      const response = await fetch(imagePath, { mode: "cors" });
      const blob = await response.blob();
      let base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      // Step 2: Convert to grayscale
      base64 = await convertToGrayScale(base64);

      // Step 3: Get natural dimensions
      const { width: naturalWidth, height: naturalHeight } =
        await loadImageDimensions(base64);

      // Step 4: Resize to fit dynamically within maxWidth and maxHeight
      const maxWidth = 80; // maximum width in pt for 3-inch receipt
      const maxHeight = 40; // maximum height in pt
      const widthRatio = maxWidth / naturalWidth;
      const heightRatio = maxHeight / naturalHeight;
      const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

      const imgWidth = naturalWidth * ratio;
      const imgHeight = naturalHeight * ratio;

      // Step 5: Center the logo
      const logoX = (pageWidth - imgWidth) / 2;

      doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

      y += imgHeight + 10; // spacing after logo
    } catch (err) {
      console.warn("Logo failed to load:", err);
    }
  }

  let margin = 15;
  const drawDashedLine = (yPos) => {
    doc.setLineDash([3, 3], 0);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    doc.setLineDash([]); // Reset to solid
  };
  // Header

  doc.setFont("NotoSansMono-Bold", "bold");

  doc.setFontSize(6);
  const storeTitle = documentConfig?.fromData?.title || "Store";
  doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
    doc.text(line, pageWidth / 2, y, { align: "center" });
    y += 7;
  });
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6);
  const seller = documentConfig?.fromData;
  const sellerAddressParts = [
    seller?.addressline1,
    [seller?.state].filter(Boolean).join(", "),
  ].filter(Boolean);
  doc
    .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 50)
    .forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 7;
    });

  // if (seller?.email) {
  //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
  //   y += 16;
  // }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6); // Slightly smaller to match UI

  const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
  doc.text(addressText, pageWidth / 2, y, { align: "center" });
 y += 7;

doc
  .setFont("NotoSansMono-Regular", "normal")
  .setFontSize(6);

const horizontalPadding = 12;
const leftStart = horizontalPadding;
const rightEnd = pageWidth - horizontalPadding;

// ---------- PAN ----------
const panText = seller?.pannumber
  ? `PAN: ${seller.pannumber}`
  : "";

if (panText) {
  doc.text(panText, leftStart, y, {
    align: "left",
  });
}

// ---------- PHONE ----------
const phoneNumbers = [
  documentConfig?.fromData?.phone,
  documentConfig?.fromData?.additionalPhone,
].filter(Boolean);

let phoneLineCount = 0;

if (phoneNumbers.length > 0) {
  // First number
  const firstPhone = `Ph: ${phoneNumbers[0]}`;

  doc.text(firstPhone, rightEnd, y, {
    align: "right",
  });

  phoneLineCount = 1;

  // Additional number on next line
  if (phoneNumbers[1]) {
    const additionalPhone = `, ${phoneNumbers[1]}`;

    doc.text(additionalPhone, rightEnd, y + 8, {
      align: "right",
    });

    phoneLineCount = 2;
  }
}

// ---------- Move to FASSI row ----------
const phoneHeight = phoneLineCount > 0
  ? phoneLineCount * 4
  : 0;

y += Math.max(10, phoneHeight + 6);

// ---------- FASSI ----------
const fassiTest = seller?.fssai
  ? `FASSI: ${seller.fssai}`
  : "";

if (fassiTest) {
  doc
    .setFont("NotoSansMono-Regular", "normal")
    .setFontSize(6);

  doc.text(fassiTest, leftStart, y, {
    align: "left",
  });

  y += 10;
}

// ---------- CIN ----------
const cinTest = seller?.cinnumber
  ? `CIN: ${seller.cinnumber}`
  : "";

if (cinTest) {
  doc
    .setFont("NotoSansMono-Regular", "normal")
    .setFontSize(6);

  doc.text(cinTest, leftStart, y, {
    align: "left",
  });
}

y += 7;
  const storeBoxPadding = 4;

  doc.setLineWidth(1);
  doc.setLineDash([1, 1]); // solid border

  y += 8;
  const invoiceTitle =
    data?.status === "CANCELLED"
      ? "CANCELLED TAX INVOICE"
      :documentConfig?.title;

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(7);
  const textWidth = doc.getTextWidth(invoiceTitle);
  const gap = 8; // Space between the line and the text
  margin = 10;
  // 5. Draw the Lines
  let centerX = pageWidth / 2;
  doc.text(invoiceTitle, centerX, y, { align: "center" });
  doc.setLineWidth(1);
  doc.setLineDash([3, 3]); // Use [0] for a solid line, [2, 2] for dashed like your image

  // Left Line: starts at margin, ends just before the text
  doc.line(margin, y - 4, centerX - textWidth / 2 - gap, y - 4);

  // Right Line: starts just after the text, ends at margin
  doc.line(centerX + textWidth / 2 + gap, y - 4, pageWidth - margin, y - 4);

  // 6. Reset Dash and move Y
  doc.setLineDash([]);
  y += 7;

  const { date, time } = documentConfig?.Date
  const lineHeight = 7; // Adjusted for tighter spacing seen in UI
  const leftColX = 8; // Left margin
  const rightColX = pageWidth / 2 + 10; // Start of the second column
  const drawField = (label, value, xPos, yPos) => {
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);
    const fieldText = `${label} : ${value}`;
    doc.text(fieldText, xPos, yPos);
  };
  drawField(documentConfig?.numberLabel, `${documentConfig?.number}`, leftColX, y);
  // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
  y += lineHeight;

  // Row 2: Date
  drawField("Date", `${date}, ${time}`, leftColX, y);
  y += lineHeight;

  // Row 3: Cashier
  // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

  const labelX = 8; // Left-aligned label start
  const colonX = 110; // Colon aligned at this point
  const valueX = 120; // Value starts after colon

  // y += 12;
  const buyer = documentConfig?.toData;
  const hasBuyerInfo =
    buyer &&
    (buyer?.name ||
      buyer?.phone ||
      buyer?.addressline1 ||
      buyer?.email ||
      buyer?.gstnumber ||
      buyer?.pannumber ||
      buyer?.cinnumber);

  if (hasBuyerInfo) {
    // 1. Section Header: Clean and Centered
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);
    doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
    y += 7;

    const leftMargin = 10;
    const lineHeight = 7;

    // 2. Buyer Name: Bold and Uppercase for Impact
    if (buyer.name) {
      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(6);
      doc.text(buyer.name.toUpperCase(), leftMargin, y);
      y += lineHeight;
    }

    // 3. Buyer Details: Smaller and Regular font
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6);

    // Contact Row (Phone & Email)
    if (buyer.phone || buyer.email) {
      const contactLine = [
        buyer.phone ? `Ph: ${buyer.phone}` : null,
        buyer.email ? `Email: ${buyer.email}` : null,
      ]
        .filter(Boolean)
        .join(" | ");

      doc.text(contactLine, leftMargin, y);
      y += lineHeight;
    }

    // Address: Handling long text with splitTextToSize
    const addressParts = [
      buyer.addressline1,
      [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
      buyer.pincode ? `- ${buyer.pincode}` : null,
    ]
      .filter(Boolean)
      .join(", ");

    if (addressParts) {
      const splitAddress = doc.splitTextToSize(addressParts, pageWidth - 20);
      splitAddress.forEach((line) => {
        doc.text(line, leftMargin, y);
        y += lineHeight;
      });
    }

    // 4. Statutory IDs (GST, PAN, CIN): Compact layout
     const idList = [
      { label: "GST: ", value: buyer.gstnumber, bold: true,},      
      { label: "PAN: ", value: buyer.pannumber ,bold: true,},
      { label: "CIN: ", value: buyer.cinnumber,bold: true, },
      { label: "FSSAI: ", value: buyer.fssai,bold: true, },
      { label: "Reference No: ", value: buyer.referenceid, bold: false, },
    ];
    idList.forEach((item) => {
      if (item.value) {
        const leftMargin = 10;
  if (item.bold) {
      doc.setFont("NotoSansMono-Bold", "bold");
    } else {
      doc.setFont("NotoSansMono-Regular", "normal");
    }
        // 1. Draw the Label in BOLD
        doc.setFontSize(6);
        doc.text(item.label, leftMargin, y);

        // 2. Calculate label width so the value starts exactly after it
        const labelWidth = doc.getTextWidth(item.label);

        // 3. Draw the Value in REGULAR
        doc.setFont("NotoSansMono-Regular", "normal");
        doc.text(`${item.value}`, leftMargin + labelWidth, y);

        // 4. Move to next line
        y += 7;
      }
    });

    // y += 5; // Extra spacing before the items table starts
  }

  const tableMargin = 8;
  const tableWidth = pageWidth - tableMargin * 2;

  autoTable(doc, {
    startY: y,
    margin: { left: tableMargin, right: tableMargin },
    theme: "plain",
    // 1. Set global border styles
    styles: {
      fontSize: 7,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black", // Light gray border
      lineWidth: 1,
      font: "NotoSansMono-Regular",
    },
    head: [
      // Header Row 1: "Items" label span
      [
        {
          content: "Items",
          colSpan: 3,
          styles: {
            halign: "left",
            fontStyle: "bold",
            lineWidth: { left: 1, right: 1, top: 1, bottom: 0 },
          },
        },
      ],
      // Header Row 2: Rate, Qty, Total
      [
        {
          content: "Rate",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { left: 1, top: 0, bottom: 1 },
          },
        },
        {
          content: "Qty",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { top: 0, bottom: 1 },
          },
        },
        {
          content: "Total",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { right: 1, top: 0, bottom: 1 },
          },
        },
      ],
    ],
    body: documentConfig?.items.flatMap((item) => [
      // Line 1: Item Name (Full width)
      [
        {
          content: item.title + (item.note ? ` (${item.note})` : ""),
          colSpan: 3,
          styles: {
            halign: "left",
            lineWidth: { left: 1, right: 1, top: 0, bottom: 0 },
          },
        },
      ],
      // Line 2: Values (Rate, Qty, Total)
      [
        {
          content: `${item.soldprice}`,
          styles: {
            halign: "center",
            lineWidth: { left: 1, top: 0, bottom: 0 },
          },
        },
        {
          content: `${item?.quantity} ${(() => {
            const unitCode = item?.isSecondaryUnit
              ? item?.unitConfig?.secondaryUnitCode
              : item?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
        },
        {
          content: `${item.lineTotalSoldPrice}`,
          styles: {
            halign: "center",
            lineWidth: { right: 1, top: 0, bottom: 0 },
          },
        },
      ],
    ]),
    // 3. Close the bottom border on the last row
    didDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) {
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  y = doc.lastAutoTable.finalY + 8;

  // Set dimensions for the boxes
  const boxPadding = 8;
  let boxWidth = (pageWidth - 24) / 2; // Split page width minus margins
  const boxHeight = 35; // Height to accommodate two lines of text
  const startX = 8;
  const rightBoxX = startX + boxWidth + 8;

  // --- 1. Draw Left Box (Qty & Items) ---
  doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
  doc.setLineWidth(1); // Light gray border
  doc.roundedRect(startX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);
  // Qty Line
  // doc.text("Qty :", startX + 5, y + 18);
  // doc.text(`${data.totalqty || 0}`, startX + boxWidth - 5, y + 18, { align: "right" });
  // Items Line
  doc.text("Items :", startX + 5, y + 18);
  doc.text(`${data?.totalItems}`, startX + boxWidth - 5, y + 18, {
    align: "right",
  });

  // --- 2. Draw Right Box (Total Amount) ---
  doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(7);
  const totalLabel = "Grand Total";
  const totalValue = `${documentConfig?.grandTotal}`; // Assuming raw number as per UI
  const boxCenterX = rightBoxX + boxWidth / 2;

  // Draw Label: Centered horizontally
  doc.text(totalLabel, boxCenterX, y + 10, { align: "center" });

  doc.setFontSize(7);
  doc.text(totalValue, boxCenterX, y + 22, { align: "center" });

  // // Center the content within the right box
  // const combinedText = `${totalLabel} ${totalValue}`;
  // const textWidth1 = doc.getTextWidth(combinedText);
  // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

  // doc.text(totalLabel, textStartX, y + 26);
  // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

  y += boxHeight + 7; // Advance Y position for next section

  y = checkPageBreak(doc, y);
  const boxMargin = 7;
  // 1. Prepare payment list (Only show modes with value)
  const payments = [
    { label: "Cash", amount: documentConfig?.cashPaid },
    { label: "Card", amount: documentConfig?.cardPaid },
    { label: "Online Pay", amount: documentConfig?.onlinePaid },
    { label: "UPI", amount: documentConfig?.upiPaid },
    { label: "Balance Due", amount: documentConfig?.balanceDue },
  ].filter((p) => Math.abs(parseAmount(p.amount)) > 0);

  autoTable(doc, {
    startY: y,
    theme: "plain",
    margin: { left: boxMargin, right: boxMargin },
    styles: {
      font: "NotoSansMono-Regular",
      fontSize: 6,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black",
      lineWidth: 1,
    },
    head:hasPayment
    ?  [
      [
        {
          content: "PAYMENT MODE",
          colSpan: 3,
          styles: {
            font: "NotoSansMono-Bold",
            fontSize: 6,
            cellPadding: 1,
            fontStyle: "bold",
            lineWidth: { top: 1, left: 1, right: 1, bottom: 1 },
          },
        },
      ],
    ]:[],
    body: [
      ...(hasPayment
      ?payments.map((p) => [
        { content: p.label, styles: { fontSize: 6, lineWidth: { left: 1 } } },
        { content: ":", styles: { halign: "center", lineWidth: 0 } },
        {
          content: `${p.amount}`,
          styles: { halign: "right", lineWidth: { right: 1 }, fontSize: 6 },
        },
      ]):[]),
      // Bottom Right Footer for Tender and Balance
      [
        {
          // content: `Tender: ${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
          content: `Grand Total:   ${documentConfig?.grandTotal}`,
          colSpan: 5,
          styles: {
            halign: "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            fontSize: 8,
            cellPadding: 2,
            lineWidth: { left: 1, right: 1, bottom: 1, top: 1 },
          },
        },
      ],
    ],
    columnStyles: {
      0: { cellWidth: "auto" },
      1: { cellWidth: "20" },
      2: { cellWidth: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 7;

  y = checkPageBreak(doc, y);
  if (parseAmount(documentConfig?.totalDiscount) > 0) {
    const boxMargin = 8;
    const boxHeight = 20;
    const boxWidth = pageWidth - boxMargin * 2;
    // o 1
    // 1. Draw the Container Box
    doc.setDrawColor(0); // Light Gray border
    doc.setLineWidth(1);
    doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

    // 2. Set Font for the content
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);

    const savedAmount = `${documentConfig?.totalDiscount}`;
    doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + 4, y + 12);

    // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

    y += boxHeight + 7;
  }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(10);

  y += 6;
  doc.setFontSize(7);
  doc.text("Thank you for your purchase!", pageWidth / 2, y, {
    align: "center",
  });
  y += 9;
  doc.setFont("NotoSansMono-Bold", "bold");
  doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
  const thankBoxPadding = 10;
  y += 9;

  doc.setFont("NotoSansMono-Regular", "normal");
  doc.text("Powered By", pageWidth / 2, y, { align: "center" });
  y += 9;
  doc.setFontSize(7);
  const sitePrefix = "www.";
  const siteBold = "NegoBill";
  const siteSuffix = ".com";
  const prefixWidth = doc.getTextWidth(sitePrefix);
  const boldWidth = doc.getTextWidth(siteBold);
  const suffixWidth = doc.getTextWidth(siteSuffix);
  const totalWidth = prefixWidth + boldWidth + suffixWidth;
  const startX1 = (pageWidth - totalWidth) / 2;
  if (storeSettings?.negobillBranding) {
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(sitePrefix, startX1, y);
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text(siteBold, startX1 + prefixWidth, y);
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
  }
  y += 10;
  // setPrint(false);
  return doc;
};

export const Browser2InchInvoiceReceiptM2 = async (
  data,
  qrCodeDataUrl,
  terms,
  invoiceConfig,
  selectedTheme,  
  storeSettings
) => {
   const {
    documentConfig,hasPayment     
  } = invoiceConfig;
  const doc = new jsPDF({
    unit: "pt",
    format: [144, 1000],
  });
  const pageWidth = doc.internal.pageSize.getWidth();

  let y = 10;

  const isIGST =
    documentConfig?.fromData?.statecode &&
    documentConfig?.toData?.statecode &&
    documentConfig?.fromData.statecode !== documentConfig?.toData.statecode;

  const taxRows = documentConfig?.items?.reduce((acc, product) => {
    const taxPercentage = product.taxpercentage || 0;
    const taxAmount = product.lineTotalTaxAmount || 0;
    const basePrice = product.lineTotalBasePrice || 0;
    if (!acc[taxPercentage]) {
      acc[taxPercentage] = { basePrice: 0, sgst: 0, cgst: 0, igst: 0 };
    }
    acc[taxPercentage].basePrice += basePrice;
    if (isIGST) {
      acc[taxPercentage].igst += taxAmount;
    } else {
      acc[taxPercentage].sgst += taxAmount / 2;
      acc[taxPercentage].cgst += taxAmount / 2;
    }
    return acc;
  }, {});
  const checkPageBreak = (doc, y, buffer = 20) => {
    const pageHeight = doc.internal.pageSize.getHeight();
    if (y + buffer >= pageHeight) {
      doc.addPage();
      return 14;
    }
    return y;
  };
  // const storeBoxStartY = y;

 const imagePath =  documentConfig?.image;

  // const imagePath = settings?.saleProfileData?.image
  //   ?  settings?.saleProfileData?.image
  //   : "/assets/images/logo-light.png";

  if (documentConfig?.image) {
    try {
      // Step 1: Convert image URL to base64
      const response = await fetch(imagePath, { mode: "cors" });
      const blob = await response.blob();
      let base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });

      // Step 2: Convert to grayscale
      base64 = await convertToGrayScale(base64);

      // Step 3: Get natural dimensions
      const { width: naturalWidth, height: naturalHeight } =
        await loadImageDimensions(base64);

      // Step 4: Resize to fit dynamically within maxWidth and maxHeight
      const maxWidth = 50; // maximum width in pt for 3-inch receipt
      const maxHeight = 40; // maximum height in pt
      const widthRatio = maxWidth / naturalWidth;
      const heightRatio = maxHeight / naturalHeight;
      const ratio = Math.min(widthRatio, heightRatio, 1); // don't upscale

      const imgWidth = naturalWidth * ratio;
      const imgHeight = naturalHeight * ratio;

      // Step 5: Center the logo
      const logoX = (pageWidth - imgWidth) / 2;

      doc.addImage(base64, "PNG", logoX, y, imgWidth, imgHeight);

      y += imgHeight + 10; // spacing after logo
    } catch (err) {
      console.warn("Logo failed to load:", err);
    }
  }

  let margin = 6;
  const drawDashedLine = (yPos) => {
    doc.setLineDash([3, 3], 0);
    doc.line(margin, yPos, pageWidth - margin, yPos);
    doc.setLineDash([]); // Reset to solid
  };
  // Header

  doc.setFont("NotoSansMono-Bold", "bold");

  doc.setFontSize(6);
  const storeTitle = documentConfig?.fromData?.title || "Store";
  doc.splitTextToSize(storeTitle, pageWidth - 30).forEach((line) => {
    doc.text(line, pageWidth / 2, y, { align: "center" });
    y += 7;
  });
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6);
  const seller = documentConfig?.fromData;
  const sellerAddressParts = [
    seller?.addressline1,
    [seller?.state].filter(Boolean).join(", "),
  ].filter(Boolean);
  doc
    .splitTextToSize(sellerAddressParts.join(", "), pageWidth - 50)
    .forEach((line) => {
      doc.text(line, pageWidth / 2, y, { align: "center" });
      y += 7;
    });

  // if (seller?.email) {
  //   doc.text(`Email: ${seller.email}`, pageWidth / 2, y, { align: "center" });
  //   y += 16;
  // }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6); // Slightly smaller to match UI

  const addressText = `${seller?.district} ${seller?.country} - ${seller?.pincode}`;
  doc.text(addressText, pageWidth / 2, y, { align: "center" });
  y += 7;  
   const phoneNumbers = [
  documentConfig?.fromData?.phone,
  documentConfig?.fromData?.additionalPhone,
].filter(Boolean);

if (phoneNumbers.length > 0) {
  const phoneText = `Ph: ${phoneNumbers.join(", ")}`;
  // Separate row - no wrapping
  doc.text(phoneText, pageWidth / 2, y, {
    align: "center",
  });

  y += 10;
}
  const gstText = `GST: ${seller?.gstnumber || ""}`;


  const horizontalPadding = 6;
  const leftStart = horizontalPadding;
  const rightEnd = pageWidth - horizontalPadding;

  doc.text(gstText, leftStart, y, { align: "left" });
  // doc.text(phoneText, rightEnd, y, { align: "right" });
  y += 7;

  const fassiTest = `FASSI: ${seller?.fssai || ""}`;
  const panTex = `PAN: ${seller?.pannumber || ""}`;

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6);
  {
    seller?.fssai && doc.text(fassiTest, rightEnd, y, { align: "right" });
  }
  doc.text(panTex, leftStart, y, { align: "left" });
  y += 7;

  const cinTest = `CIN: ${seller?.cinnumber || ""}`;

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6);
  {
    seller?.cinnumber && doc.text(cinTest, leftStart, y, { align: "left" });
  }

  const storeBoxPadding = 4;

  doc.setLineWidth(1);
  doc.setLineDash([1, 1]); // solid border

  y += 8;
  const invoiceTitle =
    data?.status === "CANCELLED"
      ? "CANCELLED TAX INVOICE"
      :documentConfig?.title;

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(7);
  const textWidth = doc.getTextWidth(invoiceTitle);
  const gap = 8; // Space between the line and the text
  margin = 10;
  // 5. Draw the Lines
  let centerX = pageWidth / 2;
  doc.text(invoiceTitle, centerX, y, { align: "center" });
  doc.setLineWidth(1);
  doc.setLineDash([3, 3]); // Use [0] for a solid line, [2, 2] for dashed like your image

  // Left Line: starts at margin, ends just before the text
  doc.line(margin, y - 4, centerX - textWidth / 2 - gap, y - 4);

  // Right Line: starts just after the text, ends at margin
  doc.line(centerX + textWidth / 2 + gap, y - 4, pageWidth - margin, y - 4);

  // 6. Reset Dash and move Y
  doc.setLineDash([]);
  y += 10;

  const { date, time } = documentConfig?.Date
  const lineHeight = 7; // Adjusted for tighter spacing seen in UI
  const leftColX = 8; // Left margin
  const rightColX = pageWidth / 2 + 10; // Start of the second column
  const drawField = (label, value, xPos, yPos) => {
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);
    const fieldText = `${label} : ${value}`;
    doc.text(fieldText, xPos, yPos);
  };
  drawField(
    documentConfig?.numberLabel ,
    `${documentConfig?.number}`,
    leftColX,
    y,
  );
  // drawField("Counter", "02", rightColX, y); // Replace "02" with your dynamic counter data
  y += lineHeight;

  // Row 2: Date
  drawField("Date", `${date}, ${time}`, leftColX, y);
  y += lineHeight;

  // Row 3: Cashier
  // drawField("Cashier", "Stejo", leftColX, y); // Replace "Stejo" with your dynamic cashier data

  const labelX = 8; // Left-aligned label start
  const colonX = 110; // Colon aligned at this point
  const valueX = 120; // Value starts after colon

  // y += 12;

  const buyer = documentConfig?.toData;
  const hasBuyerInfo =
    buyer &&
    (buyer?.name ||
      buyer?.phone ||
      buyer?.addressline1 ||
      buyer?.email ||
      buyer?.gstnumber ||
      buyer?.pannumber ||
      buyer?.cinnumber);

  // --- BUYER INFORMATION SECTION ---
  if (hasBuyerInfo) {
    // 1. Section Header: Clean and Centered
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);
    doc.text("BUYER INFORMATION", pageWidth / 2, y, { align: "center" });
    y += 8;

    const leftMargin = 10;
    const lineHeight = 9;

    // 2. Buyer Name: Bold and Uppercase for Impact
    if (buyer.name) {
      doc.setFont("NotoSansMono-Bold", "bold").setFontSize(6);
      doc.text(buyer.name.toUpperCase(), leftMargin, y);
      y += lineHeight;
    }

    // 3. Buyer Details: Smaller and Regular font
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(6);

    // Contact Row (Phone & Email)
    if (buyer.phone || buyer.email) {
      const contactLine = [
        buyer.phone ? `Ph: ${buyer.phone}` : null,
        buyer.email ? `Email: ${buyer.email}` : null,
      ]
        .filter(Boolean)
        .join(" | ");

      doc.text(contactLine, leftMargin, y);
      y += lineHeight;
    }

    // Address: Handling long text with splitTextToSize
    const addressParts = [
      buyer.addressline1,
      [buyer.state, buyer.district, buyer.country].filter(Boolean).join(", "),
      buyer.pincode ? `- ${buyer.pincode}` : null,
    ]
      .filter(Boolean)
      .join(", ");

    if (addressParts) {
      const splitAddress = doc.splitTextToSize(addressParts, pageWidth - 20);
      splitAddress.forEach((line) => {
        doc.text(line, leftMargin, y);
        y += lineHeight;
      });
    }

    // 4. Statutory IDs (GST, PAN, CIN): Compact layout
     const idList = [
      { label: "GST: ", value: buyer.gstnumber, bold: true,},      
      { label: "PAN: ", value: buyer.pannumber ,bold: true,},
      { label: "CIN: ", value: buyer.cinnumber,bold: true, },
      { label: "FSSAI: ", value: buyer.fssai,bold: true, },
      { label: "Reference No: ", value: buyer.referenceid, bold: false, },
    ];
    idList.forEach((item) => {
      if (item.value) {
        const leftMargin = 8;

        // 1. Draw the Label in BOLD
         if (item.bold) {
      doc.setFont("NotoSansMono-Bold", "bold");
    } else {
      doc.setFont("NotoSansMono-Regular", "normal");
    }
    doc.setFontSize(6);
        doc.text(item.label, leftMargin, y);

        // 2. Calculate label width so the value starts exactly after it
        const labelWidth = doc.getTextWidth(item.label);

        // 3. Draw the Value in REGULAR
        doc.setFont("NotoSansMono-Regular", "normal");
        doc.text(`${item.value}`, leftMargin + labelWidth, y);

        // 4. Move to next line
        y += 9;
      }
    });

    // y += 5; // Extra spacing before the items table starts
  }

  // Define table boundaries
  const tableMargin = 6;
  const tableWidth = pageWidth - tableMargin * 2;

  autoTable(doc, {
    startY: y,
    margin: { left: tableMargin, right: tableMargin },
    theme: "plain",
    // 1. Set global border styles
    styles: {
      fontSize: 6,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black", // Light gray border
      lineWidth: 1,
      font: "NotoSansMono-Regular",
    },
    head: [
      // Header Row 1: "Items" label span
      [
        {
          content: "Items",
          colSpan: 3,
          styles: {
            halign: "left",
            fontStyle: "bold",
            lineWidth: { left: 1, right: 1, top: 1, bottom: 0 },
          },
        },
      ],
      // Header Row 2: Rate, Qty, Total
      [
        {
          content: "Rate",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { left: 1, top: 0, bottom: 1 },
          },
        },
        {
          content: "Qty",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { top: 0, bottom: 1 },
          },
        },
        {
          content: "Total",
          styles: {
            halign: "center",
            fontStyle: "bold",
            lineWidth: { right: 1, top: 0, bottom: 1 },
          },
        },
      ],
    ],
    body: documentConfig?.items.flatMap((item) => [
      // Line 1: Item Name (Full width)
      [
        {
          content: item.title + (item.note ? ` (${item.note})` : ""),
          colSpan: 3,
          styles: {
            halign: "left",
            lineWidth: { left: 1, right: 1, top: 0, bottom: 0 },
          },
        },
      ],
      // Line 2: Values (Rate, Qty, Total)
      [
        {
          content: `${item.soldprice}`,
          styles: {
            halign: "center",
            lineWidth: { left: 1, top: 0, bottom: 0 },
          },
        },
        {
          content: `${item?.quantity} ${(() => {
            const unitCode = item?.isSecondaryUnit
              ? item?.unitConfig?.secondaryUnitCode
              : item?.unitConfig?.primaryUnitCode;
            return unitCode || "";
          })()}`,
          styles: { halign: "center", lineWidth: { top: 0, bottom: 0 } },
        },
        {
          content: `${item.lineTotalSoldPrice}`,
          styles: {
            halign: "center",
            lineWidth: { right: 1, top: 0, bottom: 0 },
          },
        },
      ],
    ]),
    // 3. Close the bottom border on the last row
    didDrawCell: (data) => {
      if (data.row.index === data.table.body.length - 1) {
        doc.setDrawColor(0);
        doc.setLineWidth(1);
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.cell.width,
          data.cell.y + data.cell.height,
        );
      }
    },
  });

  y = doc.lastAutoTable.finalY + 5;

  // Set dimensions for the boxes
  const boxPadding = 8;
  let boxWidth = (pageWidth - 24) / 2; // Split page width minus margins
  const boxHeight = 30; // Height to accommodate two lines of text
  const startX = 8;
  const rightBoxX = startX + boxWidth + 8;

  // --- 1. Draw Left Box (Qty & Items) ---
  doc.setDrawColor(0); // Changed from 200 to 150 for a darker, printable gray
  doc.setLineWidth(1); // Light gray border
  doc.roundedRect(startX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(7);
  // Qty Line
  // doc.text("Qty :", startX + 5, y + 18);
  // doc.text(`${data.totalqty || 0}`, startX + boxWidth - 5, y + 18, { align: "right" });
  // Items Line
  doc.text("Items :", startX + 5, y + 18);
  doc.text(`${data?.totalItems}`, startX + boxWidth - 5, y + 18, {
    align: "right",
  });

  // --- 2. Draw Right Box (Total Amount) ---
  doc.roundedRect(rightBoxX, y, boxWidth, boxHeight, 3, 3, "S");

  doc.setFont("NotoSansMono-Bold", "bold").setFontSize(7);
  const totalLabel = "Grand Total";
  const totalValue = `${documentConfig?.grandTotal}`; // Assuming raw number as per UI
  const boxCenterX = rightBoxX + boxWidth / 2;

  // Draw Label: Centered horizontally
  doc.text(totalLabel, boxCenterX, y + 10, { align: "center" });

  doc.setFontSize(7);
  doc.text(totalValue, boxCenterX, y + 22, { align: "center" });

  // // Center the content within the right box
  // const combinedText = `${totalLabel} ${totalValue}`;
  // const textWidth1 = doc.getTextWidth(combinedText);
  // const textStartX = rightBoxX + (boxWidth - textWidth1) / 2;

  // doc.text(totalLabel, textStartX, y + 26);
  // doc.text(totalValue, textStartX + doc.getTextWidth(totalLabel) + 4, y + 26);

  y += boxHeight + 7; // Advance Y position for next section

  y = checkPageBreak(doc, y);
  const boxMargin = 8;
  // 1. Prepare payment list (Only show modes with value)
  const payments = [
    { label: "Cash", amount: documentConfig?.cashPaid },
    { label: "Card", amount: documentConfig?.cardPaid },
    { label: "Online Pay", amount: documentConfig?.onlinePaid },
    { label: "UPI", amount: documentConfig?.upiPaid },
    { label: "Balance Due", amount: documentConfig?.balanceDue },
  ].filter((p) => Math.abs(parseAmount(p.amount)) > 0);

  autoTable(doc, {
    startY: y,
    theme: "plain",
    margin: { left: boxMargin, right: boxMargin },
    styles: {
      font: "NotoSansMono-Regular",
      fontSize: 5,
      cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
      lineColor: "black",
      lineWidth: 1,
    },
    head: hasPayment
    ?[
      [
        {
          content: "PAYMENT MODE",
          colSpan: 3,
          styles: {
            font: "NotoSansMono-Bold",
            fontSize: 5,
            cellPadding: 1,
            fontStyle: "bold",
            lineWidth: { top: 1, left: 1, right: 1, bottom: 1 },
          },
        },
      ],
    ]:[],
    body: [
      ...(hasPayment
      ?payments.map((p) => [
        { content: p.label, styles: { fontSize: 5, lineWidth: { left: 1 } } },
        { content: ":", styles: { halign: "center", lineWidth: 0 } },
        {
          content: `${p.amount}`,
          styles: { halign: "right", lineWidth: { right: 1 }, fontSize: 5 },
        },
      ]):[]),
      // Bottom Right Footer for Tender and Balance
      [
        {
          // content: `Tender: ${CurrencyConverter.toCurrency(data.cashamount || 0||0, "INR")}\nBalance: ${CurrencyConverter.toCurrency(data.cashchange || 0||0, "INR")}`,
          content: `Grand Total:   ${documentConfig?.grandTotal}`,
          colSpan: 5,
          styles: {
            halign: "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            fontSize: 8,
            cellPadding: 2,
            lineWidth: { left: 1, right: 1, bottom: 1, top: 1 },
          },
        },
      ],
    ],
    columnStyles: {
      0: { cellWidth: "auto" },
      1: { cellWidth: "20" },
      2: { cellWidth: "auto" },
    },
  });

  y = doc.lastAutoTable.finalY + 7;

  // ---------- TAX TABLE SECTION (FULL) ----------

  // 1. Build Tax Head
  const taxHead = isIGST
    ? [["Tax", "Amount", "IGST"]]
    : [["Tax", "Amount", "SGST", "CGST"]];

  // 2. Build Tax Body
  const taxBody = Object.entries(taxRows)
    .filter(([percent]) => parseFloat(percent) > 0)
    .map(([percent, t]) =>
      isIGST
        ? [`${percent}%`, `${t.basePrice}`, `${t.igst}`]
        : [`${percent}%`, `${t.basePrice}`, `${t.sgst}`, `${t.cgst}`],
    );

  // 3. Render Table Only If Tax Exists
  if (taxBody.length > 0) {
    const tableMargin = 8;

    autoTable(doc, {
      startY: y,
      margin: { left: tableMargin, right: tableMargin },
      theme: "plain",

      styles: {
        fontSize: 5,
        cellPadding: { top: 0.5, right: 1, bottom: 0.2, left: 1 },
        lineColor: "black",
        lineWidth: 0,
        font: "NotoSansMono-Regular",
        fontStyle: "normal",
      },

      // 4. Dynamic Head
      head: taxHead.map((row) =>
        row.map((cell, colIndex) => ({
          content: cell,
          styles: {
            halign: colIndex === 0 ? "left" : "right",
            font: "NotoSansMono-Bold",
            fontStyle: "bold",
            lineWidth: {
              top: 1,
              bottom: 0,
              left: colIndex === 0 ? 1 : 0,
              right: colIndex === row.length - 1 ? 1 : 0,
            },
          },
        })),
      ),

      // 5. Dynamic Body
      body: taxBody.map((row) =>
        row.map((cell, colIndex) => ({
          content: cell,
          styles: {
            halign: colIndex === 0 ? "left" : "right",
            lineWidth: {
              left: colIndex === 0 ? 1 : 0,
              right: colIndex === row.length - 1 ? 1 : 0,
              top: 0,
              bottom: 0,
            },
          },
        })),
      ),

      // 6. Draw Bottom Border for Last Row
      didDrawCell: (data) => {
        if (
          data.row.section === "body" &&
          data.row.index === data.table.body.length - 1
        ) {
          doc.setDrawColor(0);
          doc.setLineWidth(1);
          doc.line(
            data.cell.x,
            data.cell.y + data.cell.height,
            data.cell.x + data.cell.width,
            data.cell.y + data.cell.height,
          );
        }
      },
    });

    // 7. Move Y After Tax Table
    y = doc.lastAutoTable.finalY + 5;
  }
  y = checkPageBreak(doc, y);
  if (parseAmount(documentConfig?.totalDiscount) > 0) {
    const boxMargin = 8;
    const boxHeight = 15;
    const boxWidth = pageWidth - boxMargin * 2;
    // o 1
    // 1. Draw the Container Box
    doc.setDrawColor(0); // Light Gray border
    doc.setLineWidth(1);
    doc.rect(boxMargin, y, boxWidth, boxHeight, "S");

    // 2. Set Font for the content
    doc.setFont("NotoSansMono-Regular", "normal").setFontSize(5);

    const savedAmount = `${documentConfig?.totalDiscount}`;
    doc.text(`YOU SAVED :  ${savedAmount}`, boxMargin + 4, y + 9);

    // doc.text(savedAmount, pageWidth - (boxMargin + 4), y + 14, { align: "right" });

    y += boxHeight + 8;
  }
  doc.setFont("NotoSansMono-Regular", "normal").setFontSize(12);

  // y += 10;
  doc.setFontSize(7);
  doc.text("Thank you for your purchase!", pageWidth / 2, y, {
    align: "center",
  });
  y += 8;
  doc.setFont("NotoSansMono-Bold", "bold");
  doc.text("** Visit us Again **", pageWidth / 2, y, { align: "center" });
  const thankBoxPadding = 10;
  y += 8;

  doc.setFont("NotoSansMono-Regular", "normal");
  doc.text("Powered By", pageWidth / 2, y, { align: "center" });
  y += 11;
  doc.setFontSize(8);
  const sitePrefix = "www.";
  const siteBold = "NegoBill";
  const siteSuffix = ".com";
  const prefixWidth = doc.getTextWidth(sitePrefix);
  const boldWidth = doc.getTextWidth(siteBold);
  const suffixWidth = doc.getTextWidth(siteSuffix);
  const totalWidth = prefixWidth + boldWidth + suffixWidth;
  const startX1 = (pageWidth - totalWidth) / 2;
  if (storeSettings?.negobillBranding) {
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(sitePrefix, startX1, y);
    doc.setFont("NotoSansMono-Bold", "bold");
    doc.text(siteBold, startX1 + prefixWidth, y);
    doc.setFont("NotoSansMono-Regular", "normal");
    doc.text(siteSuffix, startX1 + prefixWidth + boldWidth, y);
    y += 10;
  }
  // setPrint(false);
  return doc;
};
